/* ==========================================================================
   Skogstad Sport – global JavaScript
   Eies av forside-agenten. Motstykket til assets/skogstad-globalt.css.

   Egen fil, ikke theme.js, så Archetypes temaoppdateringer ikke overskriver
   arbeidet vårt. Lastes med defer fra layout/theme.liquid, etter theme.js,
   så theme.Currency og temaets hendelser finnes.

   Omdøpt fra skogstad-custom.js 30.07.2026 for å følge navnekonvensjonen
   etter at eierskapet ble delt. skogstad-custom.css eies av
   produktside-agenten og hører ikke sammen med denne.
   ========================================================================== */
(function () {
  'use strict';

  /* ------------------------------------------------------------------------
     Fraktterskel-måler

     Holder teksten og framdriftsstolpen i
     snippets/skogstad-free-shipping-bar.liquid i takt med kurven.

     Hvorfor det ikke holder å lytte på 'cart:updated':
     Impulse har to ulike veier som endrer kurven, og bare den ene sender
     hendelsen.

       cart:quantity  → handler i theme.js (~1899)  → sender cart:updated ✔
       buildCart()    → cartMarkup() (~1800)        → sender INGENTING ✘

     buildCart() er den som kjører ved «legg i handlekurv» (via
     ajaxProduct:added) og ved sideinnlasting. Måleren ble derfor stående på
     serververdien fra da siden ble lastet, mens totalsummen rett over den
     var oppdatert – kurven kunne vise 1 797 kr og «Du mangler 1 000,00 kr».

     Løsningen leser i stedet råverdien theme.js selv bruker.
     templates/cart.ajax.liquid legger ut data-cart-subtotal i øre, og
     cartMarkup() injiserer den blokka i [data-products] ved hver
     oppdatering. En MutationObserver på den containeren fanger dermed alle
     veier – også framtidige – uten å patche theme.js, og uten å parse et
     formatert kronebeløp tilbake til tall.

     cart:updated beholdes i tillegg, fordi handlekurvsiden oppdaterer
     totalsummen sin uten å gå via [data-products].

     data-remaining på målerens rot holdes i synk her. Merk rekkefølgen for
     den som skal lese attributtet: denne fila lastes med defer, mens
     mersalgets skript står inline i skuffa og registrerer lytteren sin
     først. På 'cart:updated' leser mersalget derfor attributtet FØR det er
     oppdatert. Derfor regner mersalget gapet ut fra kurvsummen det selv har
     fått, og bruker attributtet bare når det ikke har noen kurv å regne av.
     ------------------------------------------------------------------------ */

  var SELECTOR_BAR = '[data-shipping-bar]';
  var SELECTOR_PRODUCTS = '[data-products]';

  function formatMoney(cents, format) {
    // Bruk temaets egen formatterer når den finnes – den kjenner butikkens
    // pengeformat, tusenskille og desimaler. Reserveløsningen er kun for det
    // tilfellet at theme.js ikke har rukket å laste.
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(cents, format);
    }
    // Reserve, kun for det tilfellet at theme.js ikke har rukket å laste.
    // Speiler butikkens format – mellomrom som tusenskille, komma som
    // desimaltegn – så et beløp aldri ser fremmed ut mot resten av siden.
    var kr = (Math.round(cents) / 100).toFixed(2).replace('.', ',');
    return kr.replace(/\B(?=(\d{3})+(?!\d)(?=,))/g, ' ') + ' kr';
  }

  function updateShippingBars(totalPrice) {
    if (typeof totalPrice !== 'number' || isNaN(totalPrice)) return;

    var bars = document.querySelectorAll(SELECTOR_BAR);

    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];
      var threshold = parseInt(bar.dataset.threshold, 10);
      if (!threshold) continue;

      var textEl = bar.querySelector('[data-shipping-bar-text]');
      var fillEl = bar.querySelector('[data-shipping-bar-fill]');
      var remaining = threshold - totalPrice;
      var reached = remaining <= 0;

      bar.classList.toggle('skogstad-shipping-bar--reached', reached);

      /* Gapet skrives tilbake til markupen, ikke bare inn i teksten.
         «Passer godt til» i skuffa trenger tallet for å kunne løfte fram en
         vare som faktisk lukker gapet, og skal ikke måtte tolke en formatert
         setning tilbake til et beløp. 0 og ikke fjernet attributt når
         terskelen er nådd – se merknaden i
         snippets/skogstad-free-shipping-bar.liquid. */
      bar.setAttribute('data-remaining', reached ? 0 : remaining);

      if (textEl) {
        if (reached) {
          textEl.textContent = bar.dataset.textReached;
        } else {
          // Plassholderen [amount] settes i Liquid, fordi oversettelsen med
          // {{ amount }} allerede er interpolert på serversiden.
          textEl.textContent = bar.dataset.textProgress.replace(
            '[amount]',
            formatMoney(remaining, bar.dataset.moneyFormat)
          );
        }
      }

      if (fillEl) {
        fillEl.style.transform = 'scaleX(' + Math.min(totalPrice / threshold, 1) + ')';
      }
    }

    /* Teksten i kunngjøringslinja er oppdatert av løkka over – den noden
       bærer også [data-shipping-bar]. Det som står igjen er å avgjøre om
       linja skal vise den i det hele tatt, og om den skal stå fast. */
    updateFraktKunngjoring(totalPrice);
  }

  /* ------------------------------------------------------------------------
     Fraktmeldingen i kunngjøringslinja

     Kalles fra updateShippingBars, som er den ENE trakta begge veiene inn
     til måleren går gjennom (cart:updated og MutationObserver-en på
     [data-products]). Dermed kan linja aldri komme i utakt med kurven –
     hadde dette vært en egen lytter, måtte den kjent begge veiene selv.

     Tilstanden regnes ut i Liquid ved sidelast også, så kunden med varer i
     kurven ser beløpet før skriptet har kjørt. Denne funksjonen tar over
     ved hver endring etterpå.

     Tre tilstander:
       tom kurv            → vanlige meldinger, linja ruller som før
       varer, mangler noe  → «Du mangler X til fri frakt», linja står fast
       varer, fri frakt    → «Du har fri frakt», linja slipper taket

     Den siste er med vilje: en kvittering skal ikke oppta toppen av skjermen
     resten av besøket. Det handlingsrettede er beløpet som mangler.
     ------------------------------------------------------------------------ */

  function updateFraktKunngjoring(totalPrice) {
    var felt = document.querySelector('[data-announcement-frakt]');
    if (!felt) return;

    var maaler = felt.querySelector('[data-shipping-bar]');
    var terskel = maaler ? parseInt(maaler.getAttribute('data-threshold'), 10) : NaN;
    if (!terskel || isNaN(terskel)) return;

    var aktiv = totalPrice > 0;
    var mangler = terskel - totalPrice;

    felt.hidden = !aktiv;

    var meldinger = document.getElementById('SkogstadAnnouncement');
    if (meldinger) {
      meldinger.classList.toggle('announcement-bar__messages--frakt', aktiv);
    }

    /* Har redaktøren slått av «Skjul ved scroll», eier innstillingen
       pinningen og vi rører den ikke. Ellers pinnes linja bare mens det
       står et beløp der kunden kan gjøre noe med. */
    var bar = felt.closest('.announcement-bar');
    if (bar && !bar.hasAttribute('data-pinnet-fra-editor')) {
      bar.classList.toggle('announcement-bar--pinned', aktiv && mangler > 0);
    }
  }

  // Leser råverdien fra markupen theme.js nettopp injiserte.
  function syncFromMarkup() {
    var el = document.querySelector('[data-cart-subtotal]');
    if (!el) return;
    var cents = parseInt(el.dataset.cartSubtotal, 10);
    if (!isNaN(cents)) updateShippingBars(cents);
  }

  /* ------------------------------------------------------------------------
     Hovedbryter for filtersidestolpen

     Skjuler hele sidestolpen på kolleksjonssider og gir produktrutenettet full
     bredde. Valget huskes, fordi en kunde som har bestemt seg for å bla i
     bilder ikke skal måtte ta det valget på nytt for hver kolleksjon.

     localStorage og ikke en cookie: valget er rent kosmetisk, angår ingen
     andre enn nettleseren det er gjort i, og skal ikke sendes til serveren ved
     hver forespørsel.

     Klassen settes på .collection-content, som er den samme kroken Impulse
     selv bruker når sidestolpen er avslått. Vi utløser altså eksisterende
     oppførsel framfor å innføre ny.
     ------------------------------------------------------------------------ */
  var FILTER_TOGGLE_KEY = 'skogstad:filters-hidden';

  /* To kontroller, én tilstand.

     Lukkekrysset sitter på sidestolpen, «Filtrer»-knappen i verktøylinja, og
     bare én av dem er synlig om gangen. Begge må likevel holdes i takt: den
     som er skjult i øyeblikket blir synlig i neste, og da må aria-expanded
     stemme før brukeren rekker å se den. */
  function applyFilterVisibility(hidden) {
    var content = document.querySelector('.collection-content');
    if (!content) return;

    content.classList.toggle('filters-hidden', hidden);

    var buttons = document.querySelectorAll('[data-filter-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute('aria-expanded', hidden ? 'false' : 'true');
    }
  }

  function initFilterToggle() {
    var buttons = document.querySelectorAll('[data-filter-toggle]');
    if (!buttons.length) return;

    var stored = null;
    try {
      stored = localStorage.getItem(FILTER_TOGGLE_KEY);
    } catch (e) {
      // Privat nettlesing kan blokkere localStorage. Da faller vi tilbake til
      // synlige filtre, som er standardtilstanden, og bryteren virker
      // fortsatt – den huskes bare ikke.
    }

    if (stored === '1') applyFilterVisibility(true);

    for (var i = 0; i < buttons.length; i++) {
      buttons[i].addEventListener('click', function () {
        var content = document.querySelector('.collection-content');
        var hidden = !(content && content.classList.contains('filters-hidden'));
        applyFilterVisibility(hidden);

        /* Flytt fokus til kontrollen som overtar, ellers står tastaturbrukeren
           igjen på en knapp som nettopp ble display:none – og fokus faller da
           tilbake til <body>, altså til toppen av siden. */
        var next = hidden
          ? document.querySelector('.collection-filter__item--toggle [data-filter-toggle]')
          : document.querySelector('.collection-sidebar__close');
        if (next) next.focus();

        try {
          localStorage.setItem(FILTER_TOGGLE_KEY, hidden ? '1' : '0');
        } catch (e) {
          // Se over.
        }
      });
    }
  }

  /* ------------------------------------------------------------------------
     Filter-UX v2 – «velg først → vis produkter» (Kristians spesifikasjon 26.08.2026)

     Slik henger det sammen i theme.js (Impulse):

       - Collection.initFilters binder en input-lytter på hvert .filter-form
         (sidestolpe + skuff). Hvert valg utløser onFormSubmit, som lukker
         skuffen og AJAX-laster hele #CollectionAjaxContent – skuffen
         inkludert – før theme.sections.reinit('collection-grid') lager nye
         instanser og hendelsen «collection:reloaded» sendes.
       - Prisglideren (noUiSlider) går utenom: PriceRange.onChange →
         renderFromFormData, uten close().
       - updateScroll() ruller til toppen av rutenettet ved hvert filtervalg.

     Ønsket oppførsel:

       MOBIL (skuffen): lokal filterstate. Valg committes IKKE fortløpende –
       kunden velger flere verdier, ser «Vis N produkter» oppdatere seg, og
       først CTA-en committer alt i ett og lukker skuffen. Én history-
       oppføring per apply.

       DESKTOP (sidestolpen): umiddelbar AJAX-oppdatering som før, men uten
       at siden hopper til toppen.

     Virkemidler, alle utenfor theme.js så jobben overlever temaoppdatering:

       1. Input-events fra skuffens skjema stoppes i capture-fasen før de
          når temaets lytter. I stedet hentes en forhåndsvisning via
          Shopify Section Rendering API (?section_id=), og tellere, brikker
          og bunnlinja i skuffen oppdateres målrettet – checked-tilstanden i
          DOM-en er den lokale sannheten og røres ikke.
       2. CTA-en slipper ETT syntetisk input-event gjennom (applying-flagget)
          – temaets egen pipeline committer alle valgene, lukker skuffen og
          flytter fokus tilbake til «Filtrer»-knappen.
       3. Lukkes skuffen uten apply (kryss, utenfor-klikk, Escape), rulles
          ucommittede valg tilbake til URL-ens committede tilstand.
       4. window.scrollTo dempes i vinduet filtervalg → collection:reloaded,
          så verken desktop-filtrering eller apply hopper til toppen.
       5. Prisglideren beholder committe-nå-oppførselen (temaets callback kan
          ikke løsnes uten å røre theme.js), men committen tar med seg alle
          ventende valg (FormData av skuffens skjema), og skuffen holdes
          åpen gjennom re-rendringen: programmatiske close() undertrykkes og
          den nye skuff-noden gjenåpnes synkront – før nettleseren tegner –
          med fokus og rulleposisjon gjenopprettet.
       6. Sortering på mobil: bottom sheet som setter #SortBy og utløser
          temaets change-håndtering. Delegerte lyttere overalt, siden hele
          seksjonen byttes ut ved AJAX.
     ------------------------------------------------------------------------ */
  function initFilterUX() {
    if (!window.theme || !theme.Drawers) return;

    /* --------------------------------------------------------------------
       Retting av feil i temaets AjaxRenderer.getUpdatedParams (theme.js).

       Originalen sletter oppføringer i en URLSearchParams MENS den itererer
       over den samme lista. Iteratoren hopper da over annenhver oppføring,
       så når to eller flere aktive filtre skal fjernes i samme operasjon
       («Nullstill alle», eller apply etter at kunden har fjernet flere valg
       i skuffen), overlever halvparten av dem. Verifisert i butikkfronten
       26.08: nullstilling fra to aktive filtre fjernet størrelsen, men lot
       fargen stå.

       Samme semantikk som originalen – fjern (nøkkel, verdi)-par som ikke
       finnes i de nye parametrene, bevar sort_by/q/options[prefix]/type,
       legg til nye ikke-tomme verdier – bare uten iterator-feilen:
       nøklene snapshotes først.
       -------------------------------------------------------------------- */
    if (theme.AjaxRenderer && theme.AjaxRenderer.prototype.getUpdatedParams) {
      theme.AjaxRenderer.prototype.getUpdatedParams = function (currentParams, newParams) {
        var clone = new URLSearchParams(currentParams);
        /* options[unavailable_products] (12.10.2026): søket skjuler helt
           utsolgte produkter, og det valget skal overleve filtrering og
           sortering. Se UTSOLGTE-PRODUKTER.md. */
        var preservedParams = ['sort_by', 'q', 'options[prefix]', 'options[unavailable_products]', 'type'];

        var keys = [];
        clone.forEach(function (value, key) {
          if (keys.indexOf(key) === -1) keys.push(key);
        });

        keys.forEach(function (key) {
          if (preservedParams.indexOf(key) !== -1) return;
          var wanted = newParams.getAll(key);
          var kept = clone.getAll(key).filter(function (value) {
            return wanted.indexOf(value) !== -1;
          });
          clone.delete(key);
          kept.forEach(function (value) { clone.append(key, value); });
        });

        newParams.forEach(function (value, key) {
          if (value !== '' && clone.getAll(key).indexOf(value) === -1) {
            clone.append(key, value);
          }
        });

        return clone;
      };

      /* Kosmetisk følgefeil i samme klasse: updateURLHash limer alltid på
         «?», også når parameterlista er tom – nullstilling etterlot
         «/collections/dame?». */
      theme.AjaxRenderer.prototype.updateURLHash = function (searchParams) {
        var qs = searchParams ? searchParams.toString() : '';
        history.pushState({}, '', window.location.pathname + (qs ? '?' + qs : ''));
      };
    }

    if (!document.getElementById('FilterDrawer')) return;

    var applying = false;      // slipp neste input-event gjennom til theme.js
    var pendingDirty = false;  // ucommittede valg i skuffen
    var holdOpen = false;      // undertrykk programmatiske close() (pris-commit)
    var holdTimer = null;
    var heldInstance = null;
    var savedScrollTop = 0;
    var savedFocusId = null;
    var suppressScroll = false;
    var suppressTimer = null;
    var previewTimer = null;
    var previewController = null;
    var sortReturnFocus = null;
    var refocusAfterReload = false;

    /* Noder byttes ut ved AJAX – slå alltid opp på nytt. */
    function getDrawer() { return document.getElementById('FilterDrawer'); }
    function getDrawerForm() {
      var d = getDrawer();
      return d ? d.querySelector('.filter-form') : null;
    }
    function getSectionId() {
      var el = document.querySelector('[data-section-type="collection-grid"]');
      return el ? el.getAttribute('data-section-id') : null;
    }

    /* ---- Scrollhopp-demper (punkt 4) ---------------------------------- */
    var origScrollTo = window.scrollTo.bind(window);
    window.scrollTo = function () {
      if (suppressScroll) return;
      return origScrollTo.apply(null, arguments);
    };
    function suppressScrollUntilReload() {
      suppressScroll = true;
      clearTimeout(suppressTimer);
      /* Sikkerhetsventil om AJAX-en feiler og collection:reloaded uteblir. */
      suppressTimer = setTimeout(function () { suppressScroll = false; }, 4000);
    }

    /* ---- close()-patch: hold åpen + revert (punkt 3 og 5) ------------- */
    var origClose = theme.Drawers.prototype.close;
    theme.Drawers.prototype.close = function (evt) {
      var isFilterDrawer = this.drawer && this.drawer.id === 'FilterDrawer';
      if (isFilterDrawer && holdOpen && !evt) {
        return; // pris-commit underveis: skuffen skal bestå
      }
      var wasOpen = this.isOpen;
      var result = origClose.call(this, evt);
      /* Rull KUN tilbake når skuffen faktisk ble lukket (isOpen har gått
         fra true til false). Temaets close(evt) kalles av window-klikk-
         lytteren ved HVERT klikk mens skuffen er åpen, og returnerer tidlig
         uten å lukke når klikket er inne i skuffen – uten denne sjekken ble
         ventende valg nullstilt ved hvert eneste trykk, så kunden bare fikk
         valgt én verdi om gangen. (Fanget ikke av de første testene: de
         brukte syntetiske input-events, som ikke utløser klikk-boblingen.) */
      if (isFilterDrawer && wasOpen && !this.isOpen && !applying && pendingDirty) {
        revertPending(); // lukket uten apply: forkast ventende valg
      }
      return result;
    };

    /* Lukking uten apply ruller valgene tilbake – tellerne likeså. */
    function revertPending() {
      pendingDirty = false;
      var form = getDrawerForm();
      if (!form) return;
      var params = new URLSearchParams(window.location.search);
      form.querySelectorAll('.tag__input').forEach(function (input) {
        input.checked = params.getAll(input.name).indexOf(input.value) !== -1;
      });
      oppdaterGruppetellere(form.closest('#FilterDrawer') || document);
      schedulePreview(0); // brikker og CTA tilbake til committed tilstand
    }

    /* ---- Lokale valg i skuffen (punkt 1) ------------------------------ */
    document.addEventListener('input', function (evt) {
      if (applying) return;
      var form = getDrawerForm();
      /* Uten seksjons-id kan forhåndsvisningen ikke hentes – da må temaets
         egen commit-per-valg få kjøre, ellers blir skuffen død. Gjelder
         ingen av dagens maler (collection og search har begge
         data-section-type="collection-grid"), men koster ingenting. */
      if (form && form.contains(evt.target) && getSectionId()) {
        evt.stopPropagation(); // theme.js får aldri se det – ingen commit
        pendingDirty = true;
        /* Gruppetelleren svarer med en gang; resten venter på rendringen. */
        oppdaterGruppetellere(form.closest('#FilterDrawer') || document);
        schedulePreview(250);
        return;
      }
      /* Sidestolpen (desktop): temaet committer som før – demp bare hoppet. */
      if (evt.target.closest && evt.target.closest('.filter-form')) {
        suppressScrollUntilReload();
        oppdaterGruppetellere(document);
      }
    }, true);

    /* ---- Tellere per filtergruppe (14.09.2026) ------------------------

       Hver gruppeoverskrift viser hvor mange valg som ligger inni den, og
       sidestolpens/skuffens overskrift viser totalen. Uten dette er et valg
       i en sammenslått gruppe usynlig – og i skuffen starter ALLE gruppene
       sammenslått.

       Tallene regnes fra DOM-en og ikke fra en hentet rendring. Grunnen er
       skuffens «velg først»-modus: der er de avkryssede boksene den eneste
       sannheten om hva kunden har valgt, og en server-rendring ligger
       alltid ett nettverkskall bak. Å telle lokalt gjør at brikka svarer i
       samme øyeblikk som haken settes, også før forhåndsvisningen er hentet.

       Prisfilteret har ingen checkbox. Det teller som ett valg når minst én
       av endene er flyttet fra ytterpunktet – samme definisjon som Liquid
       bruker (filter.min_value.value / max_value.value).
    */
    function oppdaterGruppetellere(rot) {
      var scope = rot || document;
      scope.querySelectorAll('.filter-form').forEach(function (form) {
        var total = 0;

        form.querySelectorAll('.collection-sidebar__group').forEach(function (gruppe) {
          var antall = gruppe.querySelectorAll('.tag__input:checked').length;

          var pris = gruppe.querySelector('.price-range');
          if (pris && erPrisAktiv(pris)) antall += 1;

          total += antall;

          var brikke = gruppe.querySelector('[data-skogstad-gruppe-antall]');
          var trigger = gruppe.querySelector('[data-skogstad-gruppe]');
          if (brikke) {
            brikke.textContent = antall;
            if (antall > 0) {
              brikke.removeAttribute('hidden');
            } else {
              brikke.setAttribute('hidden', '');
            }
          }
          if (trigger) trigger.classList.toggle('skogstad-gruppe--aktiv', antall > 0);
        });

        /* Overskriften over skjemaet: sidestolpen på desktop, skuffens
           tittel på mobil. De to ligger utenfor <form>, så vi går ut til
           nærmeste felles forelder framfor å slå opp id-er som finnes i to
           eksemplarer på siden. */
        var panel = form.closest('#FilterDrawer') || form.closest('.collection-sidebar');
        if (!panel) return;

        var sidebarAntall = panel.querySelector('[data-skogstad-sidebar-antall]');
        if (sidebarAntall) {
          sidebarAntall.textContent = total;
          if (total > 0) {
            sidebarAntall.removeAttribute('hidden');
          } else {
            sidebarAntall.setAttribute('hidden', '');
          }
        }

        var drawerAntall = panel.querySelector('[data-skogstad-filter-count]');
        if (drawerAntall) drawerAntall.textContent = total > 0 ? '(' + total + ')' : '';
      });
    }

    function erPrisAktiv(pris) {
      var min = pris.querySelector('.price-range__input-min');
      var max = pris.querySelector('.price-range__input-max');
      if (!min || !max) return false;
      /* Tom verdi = ingen begrensning. Ellers sammenlignes mot ytterpunktene
         i data-attributtene, som er skrevet i samme format som input-ene
         (se prisfilter-rettingen i collection-grid-filters-form.liquid). */
      var minSatt = min.value !== '' && min.value !== pris.getAttribute('data-min');
      var maxSatt = max.value !== '' && max.value !== pris.getAttribute('data-max');
      return minSatt || maxSatt;
    }

    function schedulePreview(delay) {
      clearTimeout(previewTimer);
      previewTimer = setTimeout(runPreview, delay);
    }

    function runPreview() {
      var form = getDrawerForm();
      var sectionId = getSectionId();
      if (!form || !sectionId) return;

      var params = new URLSearchParams(new FormData(form));
      /* Søkesiden: q ligger utenfor skjemaet, men avgjør grunnmengden. */
      var current = new URLSearchParams(window.location.search);
      if (current.get('q') && !params.get('q')) params.set('q', current.get('q'));
      params.set('section_id', sectionId);

      if (previewController) previewController.abort();
      previewController = new AbortController();

      fetch(window.location.pathname + '?' + params.toString(), { signal: previewController.signal })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newDrawer = doc.getElementById('FilterDrawer');
          var drawer = getDrawer();
          if (!newDrawer || !drawer) return;

          /* Bunnlinja: «Vis N produkter» + Nullstill. */
          var curFooter = drawer.querySelector('.skogstad-filter-footer');
          var newFooter = newDrawer.querySelector('.skogstad-filter-footer');
          if (curFooter && newFooter) curFooter.replaceWith(newFooter);

          /* Telleren i tittelen: «Filtrer (3)». */
          var curTitleCount = drawer.querySelector('[data-skogstad-filter-count]');
          var newTitleCount = newDrawer.querySelector('[data-skogstad-filter-count]');
          if (curTitleCount && newTitleCount) curTitleCount.textContent = newTitleCount.textContent;

          /* Brikkene øverst i skuffen – klikk håndteres delegert under. */
          var curChips = drawer.querySelector('.tag-list--active-tags');
          var newChips = newDrawer.querySelector('.tag-list--active-tags');
          if (curChips && newChips) curChips.replaceWith(newChips);

          /* Tellere og radtilstand per verdi. checked røres ikke – DOM-en
             er den lokale sannheten. Radklassene (tag--active, hide ved 0
             treff) kopieres fra den hentede rendringen, som er beregnet
             med nettopp de ventende valgene. */
          drawer.querySelectorAll('.filter-form .tag__input').forEach(function (input) {
            if (!input.id) return;
            var match = newDrawer.querySelector('#' + CSS.escape(input.id));
            if (!match) return;
            var li = input.closest('li');
            var newLi = match.closest('li');
            if (li && newLi) {
              li.className = newLi.className;
              var count = li.querySelector('.skogstad-filter-count');
              var newCount = newLi.querySelector('.skogstad-filter-count');
              if (count && newCount) count.textContent = newCount.textContent;
            }
          });

          /* Til slutt, ikke først: prisgliderens verdier kan ha blitt
             rendret på nytt over, og gruppetelleren leser dem. */
          oppdaterGruppetellere(drawer);
        })
        .catch(function () { /* avbrutt eller feilet – forrige visning står */ });
    }

    /* ---- Apply, nullstill, brikker og sortering (delegert) ------------ */
    document.addEventListener('click', function (evt) {
      if (!evt.target.closest) return;
      var drawer = getDrawer();

      var applyBtn = evt.target.closest('[data-skogstad-apply]');
      if (applyBtn) {
        evt.preventDefault();
        evt.stopPropagation();
        applyPending();
        return;
      }

      var drawerReset = evt.target.closest('[data-skogstad-drawer-reset]');
      if (drawerReset) {
        evt.preventDefault();
        evt.stopPropagation();
        resetDrawerLocal();
        return;
      }

      var clearAll = evt.target.closest('[data-skogstad-clear-all]');
      if (clearAll) {
        evt.preventDefault();
        evt.stopPropagation();
        if (drawer && drawer.contains(clearAll)) {
          resetDrawerLocal(); // i skuffen: lokalt, kunden committer med CTA-en
        } else {
          clearAllFilters(); // på siden: commit uten filtre, via temaets AJAX
        }
        return;
      }

      var sortOpen = evt.target.closest('[data-skogstad-sort-open]');
      if (sortOpen) {
        evt.preventDefault();
        openSortSheet(sortOpen);
        return;
      }

      var sortValue = evt.target.closest('[data-skogstad-sort-value]');
      if (sortValue) {
        evt.preventDefault();
        var select = document.getElementById('SortBy');
        closeSortSheet();
        if (select) {
          select.value = sortValue.getAttribute('data-skogstad-sort-value');
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }

      if (evt.target.closest('[data-skogstad-sort-close]')) {
        evt.preventDefault();
        closeSortSheet();
        return;
      }

      var chipLink = evt.target.closest('.tag-list--active-tags a');
      if (chipLink && !chipLink.classList.contains('no-ajax')) {
        if (drawer && drawer.contains(chipLink)) {
          /* Brikke i skuffen: lokal fjerning, ingen commit. Lenkas
             url_to_remove er fasiten for tilstanden minus denne verdien. */
          evt.preventDefault();
          evt.stopPropagation();
          applyParamsToForm(chipLink.getAttribute('href'));
          pendingDirty = true;
          schedulePreview(0);
        } else {
          /* Brikke på siden: temaets AJAX-fjerning – demp bare hoppet. */
          suppressScrollUntilReload();
        }
      }
    }, true);

    function applyPending() {
      var form = getDrawerForm();
      if (!form) return;
      if (!pendingDirty) {
        if (theme.FilterDrawer) theme.FilterDrawer.close();
        return;
      }
      /* Slipp ETT input-event gjennom: temaets onFormSubmit lukker skuffen,
         committer hele skjemaet og gir én history-oppføring. Målet velges
         blant radene som alt står som aktive, fordi temaets renderActiveTag
         da bare fjerner en klasse i den lukkende skuffen – i stedet for å
         legge en optimistisk brikke som blinker feil på siden. */
      var target = form.querySelector('li.tag--active .tag__input') || form.querySelector('.tag__input');
      if (!target) return;
      suppressScrollUntilReload();
      /* Temaets close() prøver å fokusere «Filtrer»-knappen etter 500 ms,
         men AJAX-en har da byttet ut noden – fokus faller til <body>. Vi
         fokuserer den NYE knappen når collection:reloaded kommer. */
      refocusAfterReload = true;
      applying = true;
      try {
        target.dispatchEvent(new Event('input', { bubbles: true }));
      } finally {
        applying = false;
      }
    }

    function resetDrawerFormControls(form) {
      form.querySelectorAll('.tag__input').forEach(function (input) {
        input.checked = false;
      });
      form.querySelectorAll('.price-range').forEach(function (el) {
        var slider = el.querySelector('.price-range__slider');
        if (slider && slider.noUiSlider) {
          /* .set() fyrer 'update' men ikke 'change' – ingen commit utløses. */
          slider.noUiSlider.set([
            parseFloat(el.dataset.min) || 0,
            parseFloat(el.dataset.max) || 100,
          ]);
        }
        el.querySelectorAll('.price-range__input').forEach(function (input) {
          input.value = '';
        });
      });
    }

    /* Nullstilling i skuffen tømmer boksene uten å committe – tellerne må
       følge med, ellers står «(3)» igjen over en tom liste. */
    function resetDrawerLocal() {
      var form = getDrawerForm();
      if (!form) return;
      resetDrawerFormControls(form);
      pendingDirty = true;
      oppdaterGruppetellere(form.closest('#FilterDrawer') || document);
      schedulePreview(0);
    }

    function clearAllFilters() {
      document.querySelectorAll('.filter-form').forEach(resetDrawerFormControls);
      var sidebarForm = null;
      document.querySelectorAll('.filter-form').forEach(function (form) {
        var drawer = getDrawer();
        if (!drawer || !drawer.contains(form)) sidebarForm = sidebarForm || form;
      });
      var form = sidebarForm || getDrawerForm();
      if (!form) return;
      var target = form.querySelector('li.tag--active .tag__input') || form.querySelector('.tag__input');
      if (!target) return;
      suppressScrollUntilReload();
      applying = true;
      try {
        target.dispatchEvent(new Event('input', { bubbles: true }));
      } finally {
        applying = false;
      }
    }

    function applyParamsToForm(href) {
      var form = getDrawerForm();
      if (!form || !href) return;
      var params = new URLSearchParams(href.split('?')[1] || '');
      form.querySelectorAll('.tag__input').forEach(function (input) {
        input.checked = params.getAll(input.name).indexOf(input.value) !== -1;
      });
    }

    /* ---- Prisglideren: committe-nå med skuffen holdt åpen (punkt 5) --- */
    document.addEventListener('pointerdown', function (evt) {
      if (!evt.target.closest) return;
      var drawer = getDrawer();
      if (!drawer) return;
      var priceRange = evt.target.closest('.price-range');
      if (!priceRange || !drawer.contains(priceRange)) return;
      if (!theme.FilterDrawer || !theme.FilterDrawer.isOpen) return;

      heldInstance = theme.FilterDrawer;
      var scrollable = drawer.querySelector('.drawer__scrollable');
      savedScrollTop = scrollable ? scrollable.scrollTop : 0;
      savedFocusId = evt.target.id || null;
      holdOpen = true;
      suppressScrollUntilReload();
      clearTimeout(holdTimer);
      /* Sikkerhetsventil: uten commit skal ikke lukking være undertrykt
         for alltid. */
      holdTimer = setTimeout(function () { holdOpen = false; }, 8000);
    }, true);

    document.addEventListener('collection:reloaded', function () {
      oppdaterGruppetellere(document);
      suppressScroll = false;
      clearTimeout(suppressTimer);
      pendingDirty = false; // alt som ble committet er nå rendret
      holdOpen = false;
      clearTimeout(holdTimer);

      if (refocusAfterReload) {
        refocusAfterReload = false;
        if (!document.documentElement.classList.contains('js-drawer-open')) {
          var filterBtn = document.querySelector('.js-drawer-open-collection-filters');
          if (filterBtn) {
            try { filterBtn.focus({ preventScroll: true }); } catch (e) { filterBtn.focus(); }
          }
        }
      }

      if (!heldInstance) return;
      var old = heldInstance;
      heldInstance = null;

      /* Lukket kunden skuffen selv mens AJAX-en var underveis, er
         js-drawer-open borte – da respekteres det. */
      if (!document.documentElement.classList.contains('js-drawer-open')) return;

      var drawer = getDrawer();
      if (!drawer || !theme.FilterDrawer || theme.FilterDrawer.isOpen) return;

      if (old !== theme.FilterDrawer) {
        old.isOpen = false;
        if (typeof old.unbindEvents === 'function') {
          try { old.unbindEvents(); } catch (e) { /* gammel node kan være borte */ }
        }
      }

      /* Gjenåpne uten vendor-open(): klassen settes synkront i samme omgang
         som DOM-utbyttingen, så det aldri tegnes en lukket tilstand.
         (.drawer er display:none → block, så ingen transition utløses.) */
      drawer.classList.add('drawer--is-open');
      theme.FilterDrawer.isOpen = true;

      var openBtn = document.querySelector('.js-drawer-open-collection-filters');
      if (openBtn) {
        openBtn.setAttribute('aria-expanded', 'true');
        theme.FilterDrawer.activeSource = openBtn;
      }

      theme.FilterDrawer.bindEvents();

      var focusEl = savedFocusId ? document.getElementById(savedFocusId) : null;
      savedFocusId = null;
      if (theme.a11y && typeof theme.a11y.trapFocus === 'function') {
        theme.a11y.trapFocus({
          container: drawer,
          namespace: 'drawer_focus',
          elementToFocus: focusEl && drawer.contains(focusEl) ? focusEl : drawer
        });
      }

      /* Etter fokus, som ellers ruller lista dit selv. */
      var scrollable = drawer.querySelector('.drawer__scrollable');
      if (scrollable) scrollable.scrollTop = savedScrollTop;
    });

    /* ---- Sortering: bottom sheet på mobil (punkt 6) -------------------- */
    function getSortSheet() { return document.getElementById('SkogstadSortSheet'); }

    function openSortSheet(opener) {
      var sheet = getSortSheet();
      if (!sheet) return;
      sortReturnFocus = opener || null;
      sheet.removeAttribute('hidden');
      var panel = sheet.querySelector('.skogstad-sort-sheet__panel');
      if (panel) panel.focus();
    }

    function closeSortSheet() {
      var sheet = getSortSheet();
      if (!sheet || sheet.hasAttribute('hidden')) return;
      sheet.setAttribute('hidden', '');
      if (sortReturnFocus && document.contains(sortReturnFocus)) sortReturnFocus.focus();
      sortReturnFocus = null;
    }

    document.addEventListener('keyup', function (evt) {
      if (evt.key === 'Escape') closeSortSheet();
    });

    /* ---- Vei ut av skuffen: sveip mot venstre lukker ------------------- */
    /* Skuffen er fullskjerm på mobil, så «trykk utenfor» finnes ikke
       lenger. Utgangene er krysset, CTA-en, Escape – og dette: et
       horisontalt sveip mot venstre (samme retning som skuffen glir ut).
       Prisglideren unntas, den eier sine egne horisontale bevegelser.
       Vertikal rulling vinner alltid: sveipet krever nesten flat vinkel. */
    var swipeStartX = null;
    var swipeStartY = null;

    document.addEventListener('touchstart', function (evt) {
      swipeStartX = null;
      swipeStartY = null;
      var drawer = getDrawer();
      if (!drawer || !theme.FilterDrawer || !theme.FilterDrawer.isOpen) return;
      if (!evt.target.closest || !drawer.contains(evt.target)) return;
      if (evt.target.closest('.price-range')) return;
      swipeStartX = evt.touches[0].clientX;
      swipeStartY = evt.touches[0].clientY;
    }, { passive: true, capture: true });

    document.addEventListener('touchend', function (evt) {
      if (swipeStartX === null) return;
      var touch = evt.changedTouches[0];
      var deltaX = touch.clientX - swipeStartX;
      var deltaY = touch.clientY - swipeStartY;
      swipeStartX = null;
      swipeStartY = null;
      if (deltaX < -70 && Math.abs(deltaY) < 40 && theme.FilterDrawer && theme.FilterDrawer.isOpen) {
        theme.FilterDrawer.close(); // uten apply: ventende valg rulles tilbake
      }
    }, { passive: true, capture: true });

    /* Første synkronisering. Liquid har alt rendret riktige tall ved full
       sidelasting; dette dekker tilbakenavigering (bfcache) og alt annet
       der DOM-en gjenopprettes med avkryssede bokser uten at noe rendres. */
    oppdaterGruppetellere(document);
  }

  /* ------------------------------------------------------------------------
     Kunngjøringslinja – valgfri rotasjon

     Av som standard. Slås den på, er dette hele implementasjonen.

     HVA SOM ERSTATTES: Impulse kjørte Flickity (theme.Slideshow) på baren –
     et fullt karusellbibliotek med dra-og-slipp, cellejustering og reflow,
     i sidens aller øverste element. Det du faktisk trenger er å bytte en
     klasse på et intervall. Alt annet – krysstoningen, stablingen, at
     skjult melding ikke kan klikkes – gjør CSS-en.

     Impulses modul er allerede satt ut av spill: theme.announcementBar.init()
     slår opp elementet #AnnouncementSlider, og markupen vår heter
     #SkogstadAnnouncement. Modulen returnerer tomt og gjør ingenting. Det er
     med vilje gjort uten å endre theme.js, som Archetype overskriver ved
     temaoppdatering.

     TILGJENGELIGHET

     Ingen aria-live. En kunngjøring som roper hver sjette sekund er verre
     enn ingen kunngjøring. Alle meldingene ligger i DOM-en samtidig, og
     opacity: 0 fjerner dem ikke fra tilgjengelighetstreet – skjermleseren
     leser derfor alle 2–3 korte meldingene én gang, i rekkefølge, som den
     ville lest et hvilket som helst avsnitt.

     Tastatur: får en lenke i en skjult melding fokus, hopper rotasjonen dit
     og stopper. Uten det ville brukeren tabbet inn i noe usynlig.

     prefers-reduced-motion: rotasjonen fortsetter, men uten krysstoning –
     CSS-en slår av transition. Å stoppe rotasjonen helt ville skjult melding
     2 og 3 permanent for nettopp de brukerne. Bevegelsen fjernes, innholdet
     beholdes.
     ------------------------------------------------------------------------ */

  var ROTATION_MS = 6000;

  function initAnnouncementRotation() {
    var root = document.getElementById('SkogstadAnnouncement');
    if (!root || root.dataset.rotate !== 'true') return;

    var slides = Array.prototype.slice.call(
      root.querySelectorAll('.announcement-bar__message')
    );
    if (slides.length < 2) return;

    var index = Math.max(0, slides.findIndex(function (el) {
      return el.classList.contains('is-active');
    }));
    var timer = null;
    var paused = false;

    function show(next) {
      if (next === index) return;
      slides[index].classList.remove('is-active');
      slides[next].classList.add('is-active');
      index = next;
    }

    function tick() {
      if (!paused) show((index + 1) % slides.length);
    }

    function start() {
      stop();
      timer = setInterval(tick, ROTATION_MS);
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    // Hover og fokus fryser rotasjonen. `paused` i tillegg til stop(), fordi
    // fokus kan komme og gå raskere enn intervallet.
    root.addEventListener('mouseenter', function () { paused = true; stop(); });
    root.addEventListener('mouseleave', function () { paused = false; start(); });

    root.addEventListener('focusin', function (evt) {
      paused = true;
      stop();
      var slide = evt.target.closest('.announcement-bar__message');
      if (slide) show(slides.indexOf(slide));
    });

    root.addEventListener('focusout', function (evt) {
      if (root.contains(evt.relatedTarget)) return;
      paused = false;
      start();
    });

    // Ingen grunn til å brenne en timer på en fane ingen ser på.
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else if (!paused) { start(); }
    });

    start();

    // Temaeditoren: bytter redaktøren blokk, skal den blokka vises.
    document.addEventListener('shopify:block:select', function (evt) {
      var slide = document.getElementById('SkogstadAnnouncement-' + evt.detail.blockId);
      if (!slide) return;
      paused = true;
      stop();
      show(slides.indexOf(slide));
    });

    document.addEventListener('shopify:block:deselect', function () {
      paused = false;
      start();
    });

    // Editoren rendrer seksjonen på nytt ved hver endring. Den gamle
    // timeren peker da på elementer som ikke finnes lenger, så den ryddes
    // bort før initAnnouncementRotation() kjører igjen mot ny markup.
    document.addEventListener('shopify:section:unload', function (evt) {
      if (evt.target.contains(root)) stop();
    }, { once: true });
  }

  /* ------------------------------------------------------------------------
     Kategori-rail – framdriftsindikator

     Seksjonen: sections/skogstad-kategorirail.liquid
     Stilene:   assets/skogstad-globalt.css (søk «Kategori-rail»)

     Railen scroller helt uten JavaScript. Dette skriptet gjør én ting: holder
     streken under kortene i takt med scrollposisjonen, og skjuler den når det
     ikke finnes noe å scrolle til. Alt annet – sveip, trackpad, Shift+hjul,
     tabbing mellom lenkene – er nettleserens eget.

     HVORFOR DET IKKE MÅLES NOE PER SCROLL-HENDELSE:
     Indikatoren er 100 % bred i CSS og krympes med scaleX, og forskyvningen
     er translateX i prosent – som er prosent av indikatorens egen bredde, og
     den er lik sporets. Regnestykket bruker derfor bare scrollLeft,
     clientWidth og scrollWidth, verdier nettleseren har fra før. Ingen
     getBoundingClientRect, ingen width-skriving, ingen layout per bilde.

     Tre ting kan endre bredder etter at vi har regnet første gang, og alle
     tre er dekket: vinduet endrer størrelse (ResizeObserver), webfonten
     lastes og kortene blir bredere (document.fonts.ready), og redaktøren
     legger til eller fjerner en kategori (shopify:section:load nederst).

     Gulvet på 12 % er der fordi tolv kategorier ellers gir en indikator på
     noen få piksler – teknisk riktig, praktisk usynlig.
     ------------------------------------------------------------------------ */

  var SELECTOR_RAIL = '[data-kategorirail]';
  var RAIL_MIN_ANDEL = 0.12;

  function koblKategorirail(rail) {
    // Temaeditoren kan sende samme rail inn flere ganger. Uten dette merket
    // ville hver runde lagt på enda et sett lyttere.
    if (rail.getAttribute('data-kategorirail-koblet') === 'true') return;

    var spor = rail.querySelector('[data-kategorirail-spor]');
    var bane = rail.querySelector('[data-kategorirail-framdrift]');
    var indikator = rail.querySelector('[data-kategorirail-indikator]');
    if (!spor || !bane || !indikator) return;

    rail.setAttribute('data-kategorirail-koblet', 'true');

    var planlagt = false;

    function tegn() {
      planlagt = false;

      var synlig = spor.clientWidth;
      var total = spor.scrollWidth;
      var rest = total - synlig;

      // Får alle kortene plass, er indikatoren ren støy. Halvpiksler i
      // layouten gjør at rest kan bli 0,5 uten at noe faktisk kan scrolles,
      // derfor terskelen på 1 og ikke 0.
      if (rest <= 1) {
        bane.hidden = true;
        return;
      }

      bane.hidden = false;

      var andel = Math.min(1, Math.max(RAIL_MIN_ANDEL, synlig / total));
      var brok = Math.min(1, Math.max(0, spor.scrollLeft / rest));

      indikator.style.setProperty('--rail-andel', String(andel));
      indikator.style.setProperty('--rail-pos', (brok * (1 - andel) * 100) + '%');
    }

    function planlegg() {
      if (planlagt) return;
      planlagt = true;
      window.requestAnimationFrame(tegn);
    }

    // passive: scrollingen skal aldri vente på oss.
    spor.addEventListener('scroll', planlegg, { passive: true });

    if (window.ResizeObserver) {
      // Sporet fanger vindusbredde, lista fanger at innholdet endrer bredde.
      var observer = new ResizeObserver(planlegg);
      observer.observe(spor);
      var liste = spor.firstElementChild;
      if (liste) observer.observe(liste);
    } else {
      window.addEventListener('resize', planlegg);
    }

    // Kortene er like brede som navnene sine, og navnene endrer bredde i det
    // Inter erstatter reservefonten.
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(planlegg);
    }

    tegn();
  }

  function initKategorirail(rot) {
    var railer = (rot || document).querySelectorAll(SELECTOR_RAIL);
    for (var i = 0; i < railer.length; i++) {
      koblKategorirail(railer[i]);
    }
  }

  /* ------------------------------------------------------------------------
     Nyheter – målgruppefaner (Herre / Dame / Barn / Junior)

     Seksjonen: sections/skogstad-nyheter.liquid
     Stilene:   assets/skogstad-globalt.css (søk «målgruppefaner»)

     ALLE PANELENE ER ALLEREDE I DOM-EN
     Å bytte fane er å fjerne `hidden` fra én <div> og sette det på tre. Ingen
     nettverkskall, ingen Section Rendering API, ingen ventetilstand – og
     dermed heller ingen spinner, ingen «kunne ikke laste»-tekst og ingen
     kappløp mellom to raske klikk. Hele denne funksjonen er attributter.

     AUTOMATISK AKTIVERING
     Piltastene bytter panel med det samme, de flytter ikke bare fokus.
     WAI-ARIA anbefaler det når panelbyttet er gratis, og det er det her:
     alternativet – piltast for å flytte, mellomrom for å velge – er to
     handlinger for noe som koster null millisekunder.

     RULLERENDE TABINDEX
     Hele fanerada er ETT tabstopp. Fire tabstopp mellom overskriften og det
     første produktet ville vært fire for mange, og en fanerad er ett valg,
     ikke fire uavhengige knapper. Piltastene navigerer inni den.

     LYTTERNE ER DELEGERT FRA document
     Samme grunn som for produktkortet: temaeditoren bygger seksjonen på nytt
     ved hver endring, og lyttere på enkeltnoder ville dødd med markupen. Det
     eneste som gjøres per node er å avdekke fanerada – og det kjøres på nytt
     ved shopify:section:load nederst i fila.
     ------------------------------------------------------------------------ */

  var SELECTOR_NYHETER = '[data-skogstad-nyheter]';
  var NY_FANE = '[data-skogstad-fane]';

  function nyhetsfaner(seksjon) {
    return Array.prototype.slice.call(seksjon.querySelectorAll(NY_FANE));
  }

  function visNyhetsgruppe(seksjon, valgt, flyttFokus) {
    var faner = nyhetsfaner(seksjon);
    if (!faner.length) return;

    for (var i = 0; i < faner.length; i++) {
      var fane = faner[i];
      var aktiv = fane === valgt;

      fane.setAttribute('aria-selected', aktiv ? 'true' : 'false');
      fane.setAttribute('tabindex', aktiv ? '0' : '-1');

      var panel = document.getElementById(fane.getAttribute('aria-controls'));
      if (!panel) continue;

      panel.hidden = !aktiv;

      /* Et skjult panel har bredde 0, og en rullestrek regnet ut på bredde 0
         er en strek på null piksler. Panelet måles derfor på nytt i det det
         blir synlig – funksjonen legges på noden av railkoblingen under. */
      if (aktiv && typeof panel.skogstadTegnRail === 'function') {
        panel.skogstadTegnRail();
      }
    }

    /* «Se alle» i seksjonshodet peker på den aktive gruppa. Adressen og
       teksten ligger på fanen selv og ikke i et oppslag her – da finnes
       koblingen mellom gruppe og lenke ett sted, i Liquid, og skriptet
       trenger ikke vite at gruppene heter Herre og Dame.

       Mobilutgaven røres ikke: der har hvert panel sin egen lenke, og det
       panelet som er skjult, tar ingen med seg. */
    var lenke = seksjon.querySelector('[data-skogstad-sealle]');
    if (lenke) {
      var url = valgt.getAttribute('data-sealle-url');
      var tekst = valgt.getAttribute('data-sealle-tekst');
      var tekstnode = lenke.querySelector('[data-skogstad-sealle-tekst]');

      if (url) lenke.setAttribute('href', url);
      if (tekstnode && tekst) tekstnode.textContent = tekst;

      /* En gruppe kan ha produkter uten å ha en kolleksjon å peke på. Da er
         det ingen «alle» å se, og lenka skjules i stedet for å stå igjen med
         forrige gruppes adresse – som ville sendt kunden til feil avdeling. */
      lenke.hidden = !url;
    }

    /* Bare ved tastaturnavigasjon. Ved museklikk har fanen allerede fokus,
       og et programmatisk focus() ville utløst fokusringen på et klikk. */
    if (flyttFokus) valgt.focus();
  }

  document.addEventListener('click', function (evt) {
    if (!evt.target.closest) return;
    var fane = evt.target.closest(NY_FANE);
    if (!fane) return;

    var seksjon = fane.closest(SELECTOR_NYHETER);
    if (!seksjon) return;

    // Klikk på den fanen som allerede er valgt skal ikke fade panelet ut og
    // inn igjen. Ingenting endret seg.
    if (fane.getAttribute('aria-selected') === 'true') return;

    // Merket som slår på innfadingen. Står ikke i markupen, så første
    // visning av seksjonen er rolig – se CSS-en.
    seksjon.setAttribute('data-byttet', '');
    visNyhetsgruppe(seksjon, fane, false);
  });

  document.addEventListener('keydown', function (evt) {
    var tast = evt.key;
    if (tast !== 'ArrowLeft' && tast !== 'ArrowRight' && tast !== 'Home' && tast !== 'End') return;
    if (!evt.target.closest) return;

    var fane = evt.target.closest(NY_FANE);
    if (!fane) return;

    var seksjon = fane.closest(SELECTOR_NYHETER);
    if (!seksjon) return;

    var faner = nyhetsfaner(seksjon);
    var naa = faner.indexOf(fane);
    if (naa === -1) return;

    // Rundgang i begge ender. En fanerad er en sirkel, ikke en linje med
    // vegger – å stoppe på den siste fanen gir ingen informasjon, det gir
    // bare et piltrykk som ikke gjorde noe.
    var neste;
    if (tast === 'Home') {
      neste = 0;
    } else if (tast === 'End') {
      neste = faner.length - 1;
    } else if (tast === 'ArrowLeft') {
      neste = (naa - 1 + faner.length) % faner.length;
    } else {
      neste = (naa + 1) % faner.length;
    }

    // Piltastene ville ellers scrollet siden vannrett i fanerada.
    evt.preventDefault();

    seksjon.setAttribute('data-byttet', '');
    visNyhetsgruppe(seksjon, faner[neste], true);
  });

  /* Per node: fanerada er usynlig (visibility: hidden) til dette merket er
     satt. Uten skript er den en tom stripe og ikke fire døde knapper – samme
     regel som framdriftsindikatoren i kategori-railen følger. */
  function initNyhetsfaner(rot) {
    var seksjoner = (rot || document).querySelectorAll(SELECTOR_NYHETER);
    for (var i = 0; i < seksjoner.length; i++) {
      if (!seksjoner[i].querySelector('[data-skogstad-faner]')) continue;
      seksjoner[i].setAttribute('data-faner', 'klar');
    }
  }

  /* ------------------------------------------------------------------------
     Nyheter – sveiperad: rullestrek og piler

     Seksjonen: sections/skogstad-nyheter.liquid
     Stilene:   assets/skogstad-globalt.css (søk «rullestrek og piler»)

     Raden scroller helt uten JavaScript – på mobil med fingeren, på desktop
     med trackpad, hjul og tastatur. Dette skriptet legger tre ting oppå:

       1. Rullestreken holdes i takt med scrollposisjonen.
       2. Streken kan dras, som en vanlig scrollbar.
       3. Pilene flytter raden én skjermbredde og slås av i hver ende.

     ALLE TRE SKJULES NÅR ALT FÅR PLASS
     Åtte produkter i et fire-kolonners rutenett kan scrolles; åtte i en rad
     på en 27-tommer kan ikke. Da er streken og pilene kontroller som lyver
     om at det finnes mer, og de forsvinner. Det er også hele grunnen til at
     de står `hidden` i markupen: uten skript er det ingen som har målt noe.

     HVORFOR DET IKKE MÅLES NOE PER SCROLL-HENDELSE
     Samme regnestykke som kategori-railen: indikatoren er 100 % bred i CSS og
     krympes med scaleX, forskyvningen er translateX i prosent av dens egen
     bredde. Dermed trengs bare scrollLeft, clientWidth og scrollWidth –
     verdier nettleseren har fra før. Ingen getBoundingClientRect per bilde.

     ET SKJULT PANEL HAR BREDDE 0
     Tre av fire paneler ligger med `hidden` og måler null. Derfor gjør tegn()
     ingenting når bredden er 0, og fanebyttet kaller den på nytt for panelet
     som ble synlig (se visNyhetsgruppe over).

     Gulvet på 8 % er der fordi tjuefire produkter ellers gir et håndtak på
     noen få piksler – teknisk riktig, praktisk umulig å ta tak i.
     ------------------------------------------------------------------------ */

  var NY_PANEL = '[data-skogstad-panel]';
  var NY_MIN_ANDEL = 0.08;

  function koblNyhetsrail(panel) {
    // Temaeditoren kan sende samme panel inn flere ganger. Uten dette merket
    // ville hver runde lagt på enda et sett lyttere.
    if (panel.getAttribute('data-rail-koblet') === 'true') return;

    var spor = panel.querySelector('[data-skogstad-nyheter-spor]');
    var bane = panel.querySelector('[data-skogstad-framdrift]');
    var indikator = panel.querySelector('[data-skogstad-indikator]');
    if (!spor || !bane || !indikator) return;

    panel.setAttribute('data-rail-koblet', 'true');

    var forrige = panel.querySelector('[data-skogstad-pil="forrige"]');
    var neste = panel.querySelector('[data-skogstad-pil="neste"]');
    var planlagt = false;

    function tegn() {
      planlagt = false;

      var synlig = spor.clientWidth;
      var total = spor.scrollWidth;
      var rest = total - synlig;

      // Skjult panel: ingenting å måle, og ingenting skal endres. Panelet
      // måles på nytt i det fanen velges.
      if (!synlig) return;

      // Får alle kortene plass, er kontrollene ren støy. Halvpiksler i
      // layouten gjør at rest kan bli 0,5 uten at noe faktisk kan scrolles,
      // derfor terskelen på 1 og ikke 0.
      if (rest <= 1) {
        bane.hidden = true;
        if (forrige) forrige.hidden = true;
        if (neste) neste.hidden = true;
        return;
      }

      bane.hidden = false;

      if (forrige) {
        forrige.hidden = false;
        forrige.disabled = spor.scrollLeft <= 1;
      }
      if (neste) {
        neste.hidden = false;
        neste.disabled = spor.scrollLeft >= rest - 1;
      }

      var andel = Math.min(1, Math.max(NY_MIN_ANDEL, synlig / total));
      var brok = Math.min(1, Math.max(0, spor.scrollLeft / rest));

      indikator.style.setProperty('--rail-andel', String(andel));
      indikator.style.setProperty('--rail-pos', (brok * (1 - andel) * 100) + '%');
    }

    function planlegg() {
      if (planlagt) return;
      planlagt = true;
      window.requestAnimationFrame(tegn);
    }

    // Fanebyttet trenger en vei inn hit. En funksjon på noden og ikke et
    // register: panelet forsvinner ut av DOM-en i temaeditoren, og da skal
    // referansen forsvinne med det.
    panel.skogstadTegnRail = planlegg;

    // passive: scrollingen skal aldri vente på oss.
    spor.addEventListener('scroll', planlegg, { passive: true });

    if (window.ResizeObserver) {
      // Sporet fanger vindusbredde, lista fanger at innholdet endrer bredde.
      var observer = new ResizeObserver(planlegg);
      observer.observe(spor);
      var liste = spor.firstElementChild;
      if (liste) observer.observe(liste);
    } else {
      window.addEventListener('resize', planlegg);
    }

    // Kortene endrer høyde og bredde i det Inter erstatter reservefonten.
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(planlegg);
    }

    /* --- Pilene ---------------------------------------------------------
       Én skjermbredde minus ett mellomrom per trykk. Ikke «ett kort»: det
       ville tatt seks trykk å komme gjennom en rad med fire synlige, og
       ikke «hele bredden»: da forsvinner kortet man så på helt ut av syne,
       og man mister stedet i raden. */
    function hopp(retning) {
      var steg = Math.max(160, spor.clientWidth - 24);
      if (spor.scrollBy) {
        spor.scrollBy({ left: retning * steg, behavior: 'smooth' });
      } else {
        spor.scrollLeft += retning * steg;
      }
    }

    if (forrige) {
      forrige.addEventListener('click', function () {
        hopp(-1);
      });
    }
    if (neste) {
      neste.addEventListener('click', function () {
        hopp(1);
      });
    }

    /* --- Dragingen ------------------------------------------------------
       Pointer-hendelser og ikke mouse+touch: én kodevei for mus, finger og
       penn, og setPointerCapture gjør at draget følger med selv når pekeren
       forlater den 20 px høye stripa. Uten PointerEvent (gamle nettlesere)
       står streken igjen som en ren indikator – den viser fortsatt riktig,
       den kan bare ikke dras. */
    if (window.PointerEvent) {
      var drar = false;

      function tilPeker(evt) {
        var boks = bane.getBoundingClientRect();
        if (!boks.width) return;

        var synlig = spor.clientWidth;
        var total = spor.scrollWidth;
        var rest = total - synlig;
        if (rest <= 1) return;

        /* Håndtaket tas i MIDTEN, ikke i venstre kant. Regner man som om
           pekeren var starten av håndtaket, hopper streken til høyre i det
           man tar tak i den – den klassiske scrollbar-feilen, og den er
           tydeligst her hvor håndtaket kan være halve sporet bredt. */
        var andel = Math.min(1, Math.max(NY_MIN_ANDEL, synlig / total));
        var handtak = boks.width * andel;
        var maks = boks.width - handtak;
        var x = evt.clientX - boks.left - handtak / 2;
        var brok = maks > 0 ? Math.min(1, Math.max(0, x / maks)) : 0;

        spor.scrollLeft = brok * rest;
      }

      bane.addEventListener('pointerdown', function (evt) {
        if (bane.hidden) return;

        drar = true;
        bane.setAttribute('data-drar', '');
        // Slår av scroll-behavior: smooth mens draget varer. Ellers glir
        // raden etter fingeren i stedet for å følge den.
        panel.setAttribute('data-drar-rail', '');

        if (bane.setPointerCapture) {
          try {
            bane.setPointerCapture(evt.pointerId);
          } catch (e) {
            /* Ikke kritisk: uten capture slutter draget når pekeren går ut
               av stripa, og det er en akseptabel degradering. */
          }
        }

        tilPeker(evt);

        // Hindrer at nettleseren starter tekstmarkering eller sidepanorering
        // oppå draget.
        evt.preventDefault();
      });

      bane.addEventListener('pointermove', function (evt) {
        if (drar) tilPeker(evt);
      });

      function sluttDrag() {
        if (!drar) return;
        drar = false;
        bane.removeAttribute('data-drar');
        panel.removeAttribute('data-drar-rail');
      }

      bane.addEventListener('pointerup', sluttDrag);
      bane.addEventListener('pointercancel', sluttDrag);
      bane.addEventListener('lostpointercapture', sluttDrag);

      /* --- Draging av selve raden ---------------------------------------
         Ta tak i kortene og dra, som man gjør med fingeren på mobil. På
         berøringsskjerm gjør nettleseren dette selv og bedre (fart,
         gummikant, snapping), så dette gjelder KUN mus – derfor
         pointerType-sjekken og ikke en breddegrense.

         Musedraging er den tredje veien inn i den samme raden, og den er
         der fordi de to andre ikke dekker alt: pilene flytter en hel
         skjermbredde om gangen, og rullestreken krever at man først finner
         en 20 px høy stripe under raden. Den som vil se litt til, vil dra
         litt.

         TERSKELEN PÅ 5 PIKSLER ER HELE FINESSEN
         Kortene er lenker. Uten terskel ville hvert eneste klikk på et
         produkt vært et null-piksels drag, og et klikk som avsluttet et
         drag skal ikke åpne noe. Under 5 px er det et klikk og lenka får
         gå; over er det et drag, og da spises det påfølgende klikket i
         capture-fasen – én gang, av lytteren som fjerner seg selv.

         Bare venstre knapp (evt.button), og aldri fra et skjemafelt eller
         en knapp inni kortet: hurtigkjøp og fargebrikker er egne kontroller
         som må kunne trykkes uten at raden flytter seg. */
      var railDrar = false;
      var railDro = false;
      var railStartX = 0;
      var railStartScroll = 0;

      function railSlutt() {
        if (!railDrar) return;
        railDrar = false;
        spor.removeAttribute('data-drar');
        panel.removeAttribute('data-drar-rail');

        if (railDro) {
          // Capture, så den treffer før lenkas egen håndtering. { once: true }
          // finnes ikke overalt, derfor fjernes den for hånd.
          var spis = function (klikk) {
            klikk.preventDefault();
            klikk.stopPropagation();
            spor.removeEventListener('click', spis, true);
          };
          spor.addEventListener('click', spis, true);
          // Kom det ingen klikk (draget endte utenfor et kort), skal
          // lytteren ikke bli liggende og spise det neste ekte klikket.
          window.setTimeout(function () {
            spor.removeEventListener('click', spis, true);
          }, 0);
        }
        railDro = false;
      }

      spor.addEventListener('pointerdown', function (evt) {
        if (evt.pointerType !== 'mouse' || evt.button !== 0) return;
        if (evt.target.closest && evt.target.closest('button, input, select, textarea, label')) return;
        if (spor.scrollWidth - spor.clientWidth <= 1) return;

        railDrar = true;
        railDro = false;
        railStartX = evt.clientX;
        railStartScroll = spor.scrollLeft;
        panel.setAttribute('data-drar-rail', '');
      });

      spor.addEventListener('pointermove', function (evt) {
        if (!railDrar) return;

        var dx = evt.clientX - railStartX;

        if (!railDro) {
          if (Math.abs(dx) < 5) return;
          railDro = true;
          spor.setAttribute('data-drar', '');
          if (spor.setPointerCapture) {
            try {
              spor.setPointerCapture(evt.pointerId);
            } catch (e) {
              /* Uten capture slutter draget når pekeren forlater raden. */
            }
          }
        }

        spor.scrollLeft = railStartScroll - dx;
        evt.preventDefault();
      });

      spor.addEventListener('pointerup', railSlutt);
      spor.addEventListener('pointercancel', railSlutt);
      spor.addEventListener('lostpointercapture', railSlutt);

      // Nettleseren starter sin egen bildedraging hvis vi ikke sier fra.
      spor.addEventListener('dragstart', function (evt) {
        if (railDro) evt.preventDefault();
      });
    }

    tegn();
  }

  function initNyhetsrail(rot) {
    var paneler = (rot || document).querySelectorAll(NY_PANEL);
    for (var i = 0; i < paneler.length; i++) {
      koblNyhetsrail(paneler[i]);
    }
  }

  /* ------------------------------------------------------------------------
     Produktkortet – fargeforhåndsvisning og hurtigkjøp

     Kortet:    snippets/skogstad-produktkort.liquid
     Stilene:   assets/skogstad-globalt.css (søk «Produktkortet»)
     Seksjoner: sections/skogstad-nyheter.liquid
                sections/skogstad-bestselgere.liquid

     Skrevet for Nyheter, men aldri bundet til den. Alt under er delegert fra
     document og velger på kortets egne data-attributter – ikke på
     seksjonsklasser – så en ny seksjon som rendrer det samme kortet får
     brikker og hurtigkjøp uten en linje her. Bestselgere er beviset: den
     seksjonen har ingen egen JavaScript.

     HVA SOM IKKE ER HER
     Ingen layout. Rutenettet på desktop, railen på mobil, krysstoningen ved
     hover og hurtigkjøp-panelet som glir opp er ren CSS. Slår man av dette
     skriptet, ser seksjonen helt lik ut, railen scroller like godt, og
     størrelsesknappene legger fortsatt varen i kurven – de er submit-knapper
     i et ekte <form action="/cart/add">, så nettleseren poster dem selv og
     lander på handlekurven. Skriptet gjør tre ting oppå det:

       1. Fargebrikkene blir virksomme (bytter bilde og størrelsesgruppe).
       2. Hurtigkjøp skjer uten sidelast, og temaets kurvskuff åpnes.
       3. Mobil får et bunnark i stedet for et hover-panel som ikke finnes.

     ALT ER DELEGERT FRA document
     Seksjonen bygges på nytt ved hver endring i temaeditoren, og kortene kan
     i framtida komme fra en AJAX-oppdatert kolleksjon. Lyttere på enkeltnoder
     ville dødd med markupen. Det eneste som gjøres per node, er å slå PÅ de
     kontrollene som ikke skal finnes uten skript – og det kjøres på nytt ved
     shopify:section:load nederst i fila.
     ------------------------------------------------------------------------ */

  var KORT_ROT = '[data-skogstad-kort]';
  var KORT_BRIKKE = '[data-skogstad-brikke]';
  var KORT_SKJEMA = '[data-skogstad-hurtig]';
  var KORT_ARK = '[data-skogstad-hurtigark]';

  var arkReturFokus = null;

  /* ---- Fargebrikker --------------------------------------------------- */

  /* Bildelagene har ingen background-image før første gang de brukes. Fire
     produkter × tre farger er tolv ekstra bilder som ellers ville lastet ned
     på en forside der de fleste aldri rører en brikke. */
  function visFarge(kort, handle, brikke) {
    var lag = kort.querySelectorAll('[data-skogstad-fargebilde]');
    for (var i = 0; i < lag.length; i++) {
      var treff = lag[i].getAttribute('data-skogstad-fargebilde') === handle;
      if (treff && !lag[i].style.backgroundImage) {
        var kilde = lag[i].getAttribute('data-kilde');
        if (kilde) lag[i].style.backgroundImage = 'url("' + kilde + '")';
      }
      if (treff) {
        lag[i].classList.add('er-aktiv');
      } else {
        lag[i].classList.remove('er-aktiv');
      }
    }

    /* Metalinja følger fargen: «Merinoull blanding sett · Casio Grey» blir
       «… · Navy» når kunden trykker en annen brikke. Typen står i
       data-skogstad-type, så navnet aldri bygges av tekst som kan ha blitt
       endret. Uten fargenavn på brikka står typen alene. */
    var meta = kort.querySelector('[data-skogstad-undertittel]');
    if (meta && brikke) {
      var type = meta.getAttribute('data-skogstad-type') || '';
      var fargenavn = brikke.getAttribute('data-skogstad-fargenavn') || '';
      /* Bare fargedelen skrives om. Linja er tre spans (type, materialrest,
         farge) siden 05.10.2026, så mobil kan vise typen alene – og
         textContent på hele linja ville slettet de to første. */
      var fargedel = meta.querySelector('[data-skogstad-metafarge]');
      if (!fargedel && fargenavn) {
        fargedel = document.createElement('span');
        fargedel.className = 'skogstad-kort__metafarge';
        fargedel.setAttribute('data-skogstad-metafarge', '');
        meta.appendChild(fargedel);
      }
      if (fargedel) {
        fargedel.textContent = fargenavn ? (type ? ' \u00b7 ' : '') + fargenavn : '';
      }
    }

    /* Rullerende tabindex: bare den valgte brikka er tabstopp. Fire kort med
       fire farger hver ville ellers lagt seksten ekstra tabstopp mellom
       produktnavnene. Piltastene flytter mellom brikkene, slik en gruppe av
       likestilte valg skal fungere. */
    var brikker = kort.querySelectorAll(KORT_BRIKKE);
    for (var j = 0; j < brikker.length; j++) {
      var valgt = brikker[j] === brikke;
      brikker[j].setAttribute('aria-pressed', valgt ? 'true' : 'false');
      brikker[j].setAttribute('tabindex', valgt ? '0' : '-1');
    }

    /* Størrelsene følger fargen. Uten dette kunne kunden valgt farge A og
       lagt størrelse fra farge B i kurven. */
    var grupper = kort.querySelectorAll('[data-skogstad-storrelsegruppe]');
    for (var k = 0; k < grupper.length; k++) {
      grupper[k].hidden = grupper[k].getAttribute('data-skogstad-storrelsegruppe') !== handle;
    }

    skjulFeil(kort);
  }

  function skjulFeil(rot) {
    var felt = rot.querySelectorAll('[data-skogstad-hurtig-feil]');
    for (var i = 0; i < felt.length; i++) {
      felt[i].hidden = true;
      felt[i].textContent = '';
    }
  }

  document.addEventListener('click', function (evt) {
    if (!evt.target.closest) return;
    var brikke = evt.target.closest(KORT_BRIKKE);
    if (!brikke) return;
    var kort = brikke.closest(KORT_ROT);
    if (!kort) return;
    visFarge(kort, brikke.getAttribute('data-skogstad-brikke'), brikke);
  });

  document.addEventListener('keydown', function (evt) {
    if (!evt.target.closest) return;
    var brikke = evt.target.closest(KORT_BRIKKE);
    if (!brikke) return;
    if (evt.key !== 'ArrowRight' && evt.key !== 'ArrowLeft') return;

    var kort = brikke.closest(KORT_ROT);
    if (!kort) return;
    var brikker = kort.querySelectorAll(KORT_BRIKKE);
    var indeks = Array.prototype.indexOf.call(brikker, brikke);
    var neste = evt.key === 'ArrowRight' ? indeks + 1 : indeks - 1;
    if (neste < 0) neste = brikker.length - 1;
    if (neste >= brikker.length) neste = 0;

    evt.preventDefault();
    visFarge(kort, brikker[neste].getAttribute('data-skogstad-brikke'), brikker[neste]);
    brikker[neste].focus();
  });

  /* ---- Bunnark på mobil ----------------------------------------------- */

  function finnArk(node) {
    var seksjon = node.closest ? node.closest('.shopify-section') : null;
    var ark = seksjon ? seksjon.querySelector(KORT_ARK) : null;
    return ark || document.querySelector(KORT_ARK);
  }

  function apneArk(utloser) {
    var skjema = utloser.closest(KORT_SKJEMA);
    var ark = finnArk(utloser);
    if (!skjema || !ark) return;

    var innhold = ark.querySelector('[data-skogstad-hurtigark-innhold]');
    var tittel = ark.querySelector('[data-skogstad-hurtigark-tittel]');
    if (!innhold) return;

    /* Kopi og ikke flytting. Flyttet vi skjemaet, ville kortet stått uten
       hurtigkjøp hvis nettleseren gikk fra mobil til desktop-bredde mens
       arket var åpent – og vi ville måttet flytte det tilbake på hver
       lukking, med risiko for å legge det i feil kort. */
    var kopi = skjema.cloneNode(true);
    var kopiUtloser = kopi.querySelector('[data-skogstad-hurtig-utloser]');
    if (kopiUtloser) kopiUtloser.remove();

    innhold.innerHTML = '';
    innhold.appendChild(kopi);
    skjulFeil(innhold);

    if (tittel) tittel.textContent = skjema.getAttribute('data-produkt-tittel') || '';

    /* Fokus skal tilbake til knappen arket ble åpnet fra når det lukkes.
       Vi husker også skjemaet i kortet: kopien i arket forsvinner når arket
       lukkes, og en hendelse fra et element som er tatt ut av DOM-en bobler
       ingen steder. Se submit-håndteringen. */
    arkReturFokus = utloser;
    ark.skogstadKildeskjema = skjema;

    ark.removeAttribute('hidden');
    utloser.setAttribute('aria-expanded', 'true');

    if (window.theme && theme.a11y && typeof theme.a11y.lockMobileScrolling === 'function') {
      theme.a11y.lockMobileScrolling('skogstad-hurtigark');
    }

    var panel = ark.querySelector('.skogstad-hurtigark__panel');
    if (panel) panel.focus();
  }

  function lukkArk(ark) {
    if (!ark || ark.hasAttribute('hidden')) return;
    ark.setAttribute('hidden', '');

    var innhold = ark.querySelector('[data-skogstad-hurtigark-innhold]');
    if (innhold) innhold.innerHTML = '';
    ark.skogstadKildeskjema = null;

    if (window.theme && theme.a11y && typeof theme.a11y.unlockMobileScrolling === 'function') {
      theme.a11y.unlockMobileScrolling('skogstad-hurtigark');
    }

    if (arkReturFokus && document.contains(arkReturFokus)) {
      arkReturFokus.setAttribute('aria-expanded', 'false');
      arkReturFokus.focus();
    }
    arkReturFokus = null;
  }

  document.addEventListener('click', function (evt) {
    if (!evt.target.closest) return;

    var utloser = evt.target.closest('[data-skogstad-hurtig-utloser]');
    if (utloser) {
      evt.preventDefault();
      apneArk(utloser);
      return;
    }

    if (evt.target.closest('[data-skogstad-hurtigark-lukk]')) {
      lukkArk(evt.target.closest(KORT_ARK));
    }
  });

  document.addEventListener('keyup', function (evt) {
    if (evt.key !== 'Escape') return;
    var apne = document.querySelectorAll(KORT_ARK + ':not([hidden])');
    for (var i = 0; i < apne.length; i++) lukkArk(apne[i]);
  });

  /* ---- Hurtigkjøp: legg i kurven -------------------------------------- */

  /* evt.submitter finnes ikke i eldre Safari. Vi noterer derfor hvilken
     knapp som ble trykket, som reserve. Uten knappen vet vi ikke hvilken
     variant det gjelder – alle størrelsene deler name="id". */
  var sistTrykket = null;

  document.addEventListener('click', function (evt) {
    if (!evt.target.closest) return;
    /* `[data-antrekk-kortkjop]` i tillegg: antrekkskortet bruker samme
       hurtigkjøp-skjema, men knappen er kortets egen «Legg i handlekurv» og
       ikke en størrelsesknapp. */
    var knapp = evt.target.closest('.skogstad-kort__storrelse, [data-antrekk-kortkjop]');
    if (knapp) sistTrykket = knapp;
  }, true);

  function visFeil(skjema, melding) {
    var felt = skjema.querySelector('[data-skogstad-hurtig-feil]');
    if (!felt) return;
    felt.textContent = melding;
    felt.hidden = false;
  }

  document.addEventListener('submit', function (evt) {
    var skjema = evt.target;
    if (!skjema.matches || !skjema.matches(KORT_SKJEMA)) return;

    /* Uten fetch lar vi nettleseren poste skjemaet som vanlig. Da havner
       kunden på handlekurven i stedet for i skuffen – tregere, men riktig. */
    if (!window.fetch) return;

    var knapp = evt.submitter || sistTrykket;
    if (!knapp || !knapp.value) return;

    evt.preventDefault();
    if (knapp.classList.contains('er-laster')) return;

    knapp.classList.add('er-laster');
    skjulFeil(skjema);

    var data = new FormData();
    data.append('id', knapp.value);
    data.append('quantity', '1');

    var url = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';

    fetch(url, {
      method: 'POST',
      body: data,
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (svar) { return svar.json(); })
      .then(function (resultat) {
        knapp.classList.remove('er-laster');

        /* 422 = varen kan ikke legges i kurven. I praksis: noen andre kjøpte
           den siste mens kortet lå åpent. Meldingen fra Shopify er allerede
           på norsk og forklarer hva som er galt. */
        if (resultat && (resultat.status === 422 || resultat.status === 404)) {
          visFeil(skjema, resultat.description || resultat.message || '');
          return;
        }

        /* Arket lukkes FØR hendelsen sendes, og hendelsen sendes fra kortets
           eget skjema – ikke fra kopien i arket.

           To grunner, begge funnet ved testing: kopien tas ut av DOM-en når
           arket lukkes, og en hendelse fra et løsrevet element bobler aldri
           opp til lytteren i theme.js. Og lukkingen låser opp scrollingen
           igjen – gjorde vi det etterpå, ville vi låst opp scrollingen
           handlekurv-skuffen nettopp hadde låst, og tatt fokus fra den. */
        var ark = skjema.closest(KORT_ARK);
        var kilde = skjema;
        if (ark) {
          kilde = ark.skogstadKildeskjema || skjema;
          lukkArk(ark);
        }

        /* Handlekurv som egen side: da er det ingen skuff å åpne. */
        if (window.theme && theme.settings && theme.settings.cartType === 'page') {
          window.location = (theme.routes && theme.routes.cartPage) || '/cart';
          return;
        }

        /* Impulses egen hendelse. theme.js sin CartDrawer lytter på den,
           bygger kurven på nytt og åpner skuffen. Vi skriver ingen kurvlogikk
           selv – det er den samme veien produktsidens «Legg i handlekurv»
           går. Hendelsen sendes fra skjemaet, som inneholder [name="id"],
           fordi andre lyttere i temaet leser den derfra.

           Vi sender IKKE 'cart:build' i tillegg: CartDrawer bygger kurven
           selv når den hører 'ajaxProduct:added', og to hendelser ville gitt
           to like nettverkskall. */
        kilde.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: resultat, addToCartBtn: knapp },
          bubbles: true
        }));
      })
      .catch(function () {
        knapp.classList.remove('er-laster');
        /* Nettverksfeil. Ikke form.submit() som reserve: den sender skjemaet
           uten knappen som ble trykket, og siden alle størrelsene deler
           name="id", ville kurven fått feil variant eller ingen. Kunden får
           beskjed og kan prøve igjen eller gå til produktsiden. */
        visFeil(skjema, skjema.getAttribute('data-feilmelding') || '');
      });
  });

  /* ---- Per node: slå på det som ikke skal finnes uten skript ---------- */

  /* Slår PÅ de kontrollene som ikke skal finnes uten skript. Dette er det
     eneste som må kjøres per node – og derfor det eneste som må kjøres på
     nytt ved shopify:section:load. */
  function initProduktkort(rot) {
    var omraade = rot || document;

    /* Fargebrikkene står med tabindex="-1" i markupen. Nå finnes det et
       skript som gjør noe når de trykkes, og da skal den valgte være
       tabbar. */
    /* Den valgte brikka er ikke alltid den første: kortet står for fargen
       prisen gjelder, og er første farge utsolgt, er det en annen. */
    var kort = omraade.querySelectorAll(KORT_ROT);
    for (var i = 0; i < kort.length; i++) {
      var forste = kort[i].querySelector(KORT_BRIKKE + '[aria-pressed="true"]') || kort[i].querySelector(KORT_BRIKKE);
      if (forste) forste.setAttribute('tabindex', '0');
    }

    /* Mobilutløseren avdekkes. CSS bestemmer om den faktisk vises – den er
       skjult over 768 px – men uten skript skal den ikke finnes i det hele
       tatt. */
    var utlosere = omraade.querySelectorAll('[data-skogstad-hurtig-utloser]');
    for (var j = 0; j < utlosere.length; j++) {
      utlosere[j].removeAttribute('hidden');
    }
  }

  /* Kolleksjons- og søkesiden rendrer det samme kortet, og der er markupen
     ikke bare ny etter en endring i temaeditoren – den er ny etter hvert
     eneste filtervalg. Impulse bytter innerHTML i #CollectionAjaxContent og
     sender «collection:reloaded» når den er ferdig (theme.js,
     Collection.renderCollectionPage).

     Hendelsen og ikke en MutationObserver: observeren ville fyrt flere ganger
     per bytte (skuffen, brikkene og rutenettet byttes i samme operasjon), og
     vi ville måttet avvise våre egne endringer. Hendelsen kommer én gang, og
     den kommer etter at temaet er ferdig med sitt.

     To ting må skje:

     1. Kortene initieres på nytt. Uten dette står brikkene i de nye kortene
        med tabindex="-1", og mobilutløseren er `hidden` – altså akkurat den
        tilstanden markupen har uten JavaScript.

     2. Et åpent bunnark lukkes. Arket viser en KOPI av skjemaet i kortet, og
        originalen forsvant med den gamle markupen. Lot vi arket stå, ville
        kunden hatt et størrelsesvalg oppå et rutenett som ikke lenger
        inneholder produktet. */
  function initKolleksjonskort() {
    document.addEventListener('collection:reloaded', function () {
      var apne = document.querySelectorAll(KORT_ARK + ':not([hidden])');
      for (var i = 0; i < apne.length; i++) lukkArk(apne[i]);

      initProduktkort();
    });
  }

  /* ------------------------------------------------------------------------
     Antrekk – «Kle deg lag på lag» (Complete the look)

     sections/skogstad-antrekk.liquid + snippets/skogstad-antrekkrad.liquid
     Stiler: skogstad-globalt.css (søk «Kle deg lag på lag»)

     HVA SEKSJONEN ER UTEN DETTE SKRIPTET
     Et ekte skjema. Størrelsene er radioknapper som heter items[0][id],
     items[1][id] …, knappen er en submit-knapp, og /cart/add tar imot hele
     antrekket i ett kall. Slår man av JavaScript, kan kunden fortsatt velge
     størrelser og legge alle plaggene i kurven – hun lander på handlekurven
     i stedet for i skuffa. Ingen død kontroll noe sted.

     HVA SKRIPTET LEGGER OPPÅ
       1. Avkryssingen. «Velg bort» kan ikke gjøres uten skript, så haken er
          `hidden` i markupen og avdekkes her.
       2. Totalsummen som følger valgene.
       3. Fargebrikkene (bytter bilde, størrelsesgruppe og pris).
       4. Bunnarket på mobil.
       5. Innleggingen uten sidelast, og temaets egen kurvskuff.

     INGEN EGEN TILSTAND
     Det finnes ikke noe state-objekt her. Sannheten er DOM-en: hvilke
     avkryssinger som er huket av, hvilken fargegruppe som er synlig, hvilken
     radioknapp som er valgt. Alt regnes ut på nytt ved hver endring. Det er
     billig – maks fem rader – og det fjerner hele klassen av feil der
     summen sier én ting og skjemaet poster noe annet.

     ALT ER DELEGERT FRA document
     Seksjonen bygges på nytt ved hver endring i temaeditoren. Lyttere på
     enkeltnoder ville dødd med markupen. Det eneste som kjøres per node er
     å avdekke kontrollene som ikke skal finnes uten skript, og det kjøres på
     nytt ved shopify:section:load nederst i fila.
     ------------------------------------------------------------------------ */

  var ANT_ROT = '[data-antrekk]';
  var ANT_RAD = '[data-antrekk-rad]';
  var ANT_SKJEMA = '[data-antrekk-skjema]';

  var antArkReturFokus = null;

  function antMobil() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function antAktivGruppe(rad) {
    var grupper = rad.querySelectorAll('[data-antrekk-gruppe]');
    for (var i = 0; i < grupper.length; i++) {
      if (!grupper[i].hasAttribute('hidden')) return grupper[i];
    }
    return grupper[0] || null;
  }

  /* Varianten raden vil legge i kurven, eller null hvis kunden ikke har valgt
     størrelse ennå. Produkter uten størrelse (lue, buff) har en fast skjult
     input i stedet for radioknapper – de er alltid «valgt». */
  function antValgtVariant(rad) {
    var gruppe = antAktivGruppe(rad);
    if (!gruppe) return null;

    var fast = gruppe.querySelector('[data-antrekk-fast]');
    if (fast) return fast;

    return gruppe.querySelector('[data-antrekk-variant]:checked');
  }

  function antErValgt(rad) {
    var boks = rad.querySelector('[data-antrekk-velg]');
    return !!(boks && boks.checked);
  }

  /* Prisen raden teller med. Er størrelsen valgt, brukes variantens egen
     pris; ellers fargegruppens. Skogstad priser størrelser likt innenfor en
     farge, men vi bruker alltid det mest presise tallet vi har – ellers ville
     summen kunnet endre seg i det kunden velger størrelse, uten at noe annet
     skjedde. */
  function antRadPris(rad) {
    var valgt = antValgtVariant(rad);
    if (valgt && valgt.getAttribute('data-pris')) {
      return parseInt(valgt.getAttribute('data-pris'), 10) || 0;
    }
    var gruppe = antAktivGruppe(rad);
    if (gruppe && gruppe.getAttribute('data-pris')) {
      return parseInt(gruppe.getAttribute('data-pris'), 10) || 0;
    }
    return 0;
  }

  function antPenger(ore) {
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      return theme.Currency.formatMoney(ore, theme.settings && theme.settings.moneyFormat);
    }
    /* Reserve hvis theme.js ikke rakk å laste. Aldri et tall uten enhet. */
    return (ore / 100).toFixed(0) + ' kr';
  }

  function antSkjulFeil(rad) {
    var felt = rad.querySelector('[data-antrekk-feil]');
    if (felt) {
      felt.hidden = true;
      felt.textContent = '';
    }
    rad.removeAttribute('data-antrekk-mangler');
  }

  function antVisFeil(rad, melding) {
    var felt = rad.querySelector('[data-antrekk-feil]');
    if (!felt) return;
    felt.textContent = melding;
    felt.hidden = false;
    rad.setAttribute('data-antrekk-mangler', '');
  }

  /* Prisen i raden skrives om når fargen eller størrelsen endres. Markupen er
     den samme som serveren tegnet: nåpris, og en <s> som er `hidden` når det
     ikke er salg. */
  /* Kortmodus: knappen bærer variant-id-en.

     Hurtigkjøpet leser `evt.submitter.value` — det er hele grensesnittet
     mellom kortet og kurven. Uten JavaScript poster radioknappen (`name="id"`)
     det samme, så verdien her er ikke en sannhet nummer to: den er den samme
     opplysningen gjort tilgjengelig for den raske veien.

     Knappen settes ALDRI `disabled`. Har kunden ikke valgt størrelse, stopper
     submit-vakten lenger ned og sier det i kortets feilfelt – en grå knapp
     uten forklaring er et blindspor, og på mobil ligger størrelsene i et ark
     som må åpnes for å kunne velges. */
  function antOppdaterKortknapp(rad) {
    var knapp = rad.querySelector('[data-antrekk-kortkjop]');
    if (!knapp) return;
    var variant = antValgtVariant(rad);
    knapp.value = variant ? variant.value : '';
  }

  function antTegnPris(rad, pris, forpris) {
    var felt = rad.querySelector('[data-antrekk-prisfelt]');
    if (!felt) return;

    var na = felt.querySelector('[data-antrekk-pris-na]');
    var forr = felt.querySelector('[data-antrekk-pris-for]');
    if (!na) return;

    na.textContent = antPenger(pris);

    if (forr) {
      if (forpris > pris) {
        forr.textContent = antPenger(forpris);
        forr.hidden = false;
        felt.setAttribute('data-antrekk-salg', '');
      } else {
        forr.textContent = '';
        forr.hidden = true;
        felt.removeAttribute('data-antrekk-salg');
      }
    }
  }

  /* Etiketten på mobilutløseren. Den forteller hva som mangler eller hva som
     er valgt, slik at kunden ser tilstanden uten å åpne arket. */
  function antOppdaterUtloser(rad) {
    var utloser = rad.querySelector('[data-antrekk-utloser]');
    if (!utloser) return;
    var tekst = utloser.querySelector('[data-antrekk-utlosertekst]');
    if (!tekst) return;

    var valgt = antValgtVariant(rad);
    var skjema = rad.closest(ANT_SKJEMA);

    if (valgt && valgt.getAttribute('data-etikett')) {
      tekst.textContent =
        (skjema && skjema.getAttribute('data-storrelse-etikett') ? skjema.getAttribute('data-storrelse-etikett') + ' ' : '') +
        valgt.getAttribute('data-etikett');
      utloser.setAttribute('data-valgt', '');
    } else if (valgt) {
      /* Fast variant uten størrelse: ingenting å velge, ingen utløser. */
      utloser.hidden = true;
    } else {
      tekst.textContent = utloser.getAttribute('data-standardtekst') || tekst.textContent;
      utloser.removeAttribute('data-valgt');
    }
  }

  /* ---- Summen og knappen ---------------------------------------------- */

  function antOppdaterSum(seksjon) {
    var skjema = seksjon.querySelector(ANT_SKJEMA);
    if (!skjema) return;

    var rader = seksjon.querySelectorAll(ANT_RAD);
    var antall = 0;
    var sum = 0;
    var mangler = 0;

    for (var i = 0; i < rader.length; i++) {
      var med = antErValgt(rader[i]);

      /* Den fravalgte raden dempes. Attributtet og ikke en CSS-:has(): haken
         er ikke søsken av det som skal dempes, og en så synlig tilstand skal
         ikke være avhengig av :has()-støtte. Rader som ikke kan velges i det
         hele tatt (utsolgt) har sin egen dempning og skal ikke få to. */
      if (rader[i].hasAttribute('data-antrekk-kan-velges')) {
        if (med) {
          rader[i].removeAttribute('data-antrekk-fravalgt');
        } else {
          rader[i].setAttribute('data-antrekk-fravalgt', '');
        }
      }

      if (!med) continue;
      antall++;
      sum += antRadPris(rader[i]);
      if (!antValgtVariant(rader[i])) mangler++;
    }

    var antallFelt = skjema.querySelector('[data-antrekk-antall]');
    if (antallFelt) {
      var mal;
      if (antall === 0) {
        mal = skjema.getAttribute('data-valgt-ingen') || '';
        antallFelt.textContent = mal;
      } else {
        mal = antall === 1
          ? (skjema.getAttribute('data-valgt-en') || '%n%')
          : (skjema.getAttribute('data-valgt-flere') || '%n%');
        antallFelt.textContent = mal.replace('%n%', antall);
      }
    }

    var totalFelt = skjema.querySelector('[data-antrekk-total]');
    if (totalFelt) totalFelt.textContent = antPenger(sum);

    /* Knappen dempes, men er aldri utilgjengelig – verken med `disabled` eller
       med aria-disabled.

       Det var aria-disabled her først, og det var feil. En knapp med
       aria-disabled="true" annonseres som utilgjengelig og behandles som
       utilgjengelig av tastatur- og automatiseringslag – det ble fanget i
       test, der knappen ikke lot seg trykke i det hele tatt. Da forsvinner
       hele poenget: kunden som har krysset av tre plagg og glemt én størrelse
       skal kunne trykke, og få vite HVILKEN rad som mangler. En låst knapp
       sier bare «nei» og lar kunden lete selv.

       Attributtet under styrer bare utseendet. Valideringen ligger i
       submit-håndteringen, der den kan peke på raden. */
    var knapp = skjema.querySelector('[data-antrekk-kjop]');
    if (knapp && !knapp.hasAttribute('data-laster')) {
      var klar = antall > 0 && mangler === 0;
      if (klar) {
        knapp.removeAttribute('data-antrekk-ikke-klar');
      } else {
        knapp.setAttribute('data-antrekk-ikke-klar', '');
      }
    }
  }

  /* ---- Fargebrikker ---------------------------------------------------- */

  function antVisFarge(rad, handle, brikke) {
    var grupper = rad.querySelectorAll('[data-antrekk-gruppe]');
    for (var i = 0; i < grupper.length; i++) {
      var treff = grupper[i].getAttribute('data-antrekk-gruppe') === handle;
      grupper[i].hidden = !treff;

      /* Faste skjulte inputs må slås av og på sammen med gruppa si. En
         `disabled` input postes ikke – uten dette ville skjemaet uten
         JavaScript sendt alle fargene på én gang. */
      var faste = grupper[i].querySelectorAll('[data-antrekk-fast]');
      for (var f = 0; f < faste.length; f++) faste[f].disabled = !treff;

      /* Størrelsen nullstilles ved fargebytte. M i svart og M i blå er to
         varianter med hvert sitt lager, og en valgt størrelse som blir
         stående over et fargebytte er den feilen kunden oppdager først i
         kurven. */
      if (!treff) {
        var valgte = grupper[i].querySelectorAll('[data-antrekk-variant]:checked');
        for (var v = 0; v < valgte.length; v++) valgte[v].checked = false;
      }
    }

    /* Rullerende tabindex: bare den valgte brikka er tabbstopp. Fire rader
       med fire farger hver ville ellers lagt seksten ekstra tabbstopp mellom
       produktnavnene. Piltastene flytter mellom brikkene. */
    var brikker = rad.querySelectorAll('[data-antrekk-brikke]');
    for (var b = 0; b < brikker.length; b++) {
      var valgt = brikker[b] === brikke;
      brikker[b].setAttribute('aria-pressed', valgt ? 'true' : 'false');
      brikker[b].setAttribute('tabindex', valgt ? '0' : '-1');
    }

    /* Miniatyren. Ett <img>, ikke ett lag per farge: bildet lastes ned først
       den dagen noen trykker på brikka. */
    var thumb = rad.querySelector('[data-antrekk-thumb]');
    if (thumb && brikke && brikke.getAttribute('data-bilde')) {
      thumb.src = brikke.getAttribute('data-bilde');
      if (brikke.getAttribute('data-bildesett')) {
        thumb.srcset = brikke.getAttribute('data-bildesett');
      }
    }

    var gruppe = antAktivGruppe(rad);
    if (gruppe) {
      antTegnPris(
        rad,
        parseInt(gruppe.getAttribute('data-pris'), 10) || 0,
        parseInt(gruppe.getAttribute('data-forpris'), 10) || 0
      );
    }

    antSkjulFeil(rad);
    antOppdaterUtloser(rad);
    antOppdaterKortknapp(rad);

    var seksjon = rad.closest(ANT_ROT);
    if (seksjon) antOppdaterSum(seksjon);
  }

  document.addEventListener('click', function (evt) {
    if (!evt.target.closest) return;
    var brikke = evt.target.closest('[data-antrekk-brikke]');
    if (!brikke) return;
    var rad = brikke.closest(ANT_RAD);
    if (!rad) return;
    antVisFarge(rad, brikke.getAttribute('data-antrekk-brikke'), brikke);
  });

  document.addEventListener('keydown', function (evt) {
    if (!evt.target.closest) return;
    var brikke = evt.target.closest('[data-antrekk-brikke]');
    if (!brikke) return;
    if (evt.key !== 'ArrowRight' && evt.key !== 'ArrowLeft') return;

    var rad = brikke.closest(ANT_RAD);
    if (!rad) return;
    var brikker = rad.querySelectorAll('[data-antrekk-brikke]');
    var indeks = Array.prototype.indexOf.call(brikker, brikke);
    var neste = evt.key === 'ArrowRight' ? indeks + 1 : indeks - 1;
    if (neste < 0) neste = brikker.length - 1;
    if (neste >= brikker.length) neste = 0;

    evt.preventDefault();
    antVisFarge(rad, brikker[neste].getAttribute('data-antrekk-brikke'), brikker[neste]);
    brikker[neste].focus();
  });

  /* ---- Bunnarket på mobil ---------------------------------------------- */

  /* Ingenting klones og ingenting flyttes. Panelet ER raden sin – CSS gjør
     det til et ark under 768 px. Derfor kan radioknappene aldri komme ut av
     takt med hverandre, og en rotasjon midt i valget er bare et nytt utsnitt.
     Rollen settes her og ikke i markupen: på desktop er panelet en rad med
     knapper, ikke en dialog, og en dialogrolle der ville vært en løgn. */
  function antApneArk(utloser) {
    var rad = utloser.closest(ANT_RAD);
    var seksjon = utloser.closest(ANT_ROT);
    if (!rad || !seksjon) return;

    antLukkAlleArk(seksjon);

    var panel = rad.querySelector('[data-antrekk-panel]');
    if (!panel) return;

    antArkReturFokus = utloser;
    rad.setAttribute('data-antrekk-apen', '');
    utloser.setAttribute('aria-expanded', 'true');

    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    var tittel = panel.querySelector('[data-antrekk-paneltittel]');
    if (tittel) {
      if (!tittel.id) tittel.id = 'AntrekkArkTittel-' + Math.random().toString(36).slice(2, 8);
      panel.setAttribute('aria-labelledby', tittel.id);
    }

    var bakteppe = seksjon.querySelector('[data-antrekk-bakteppe]');
    if (bakteppe) bakteppe.hidden = false;

    if (window.theme && theme.a11y && typeof theme.a11y.lockMobileScrolling === 'function') {
      theme.a11y.lockMobileScrolling('skogstad-antrekk');
    }

    panel.focus();
  }

  function antLukkArk(rad, flyttFokus) {
    if (!rad || !rad.hasAttribute('data-antrekk-apen')) return;
    rad.removeAttribute('data-antrekk-apen');

    var panel = rad.querySelector('[data-antrekk-panel]');
    if (panel) {
      panel.removeAttribute('role');
      panel.removeAttribute('aria-modal');
      panel.removeAttribute('aria-labelledby');
    }

    var utloser = rad.querySelector('[data-antrekk-utloser]');
    if (utloser) utloser.setAttribute('aria-expanded', 'false');

    var seksjon = rad.closest(ANT_ROT);
    if (seksjon) {
      var bakteppe = seksjon.querySelector('[data-antrekk-bakteppe]');
      if (bakteppe) bakteppe.hidden = true;
    }

    if (window.theme && theme.a11y && typeof theme.a11y.unlockMobileScrolling === 'function') {
      theme.a11y.unlockMobileScrolling('skogstad-antrekk');
    }

    if (flyttFokus && antArkReturFokus && document.contains(antArkReturFokus)) {
      antArkReturFokus.focus();
    }
    antArkReturFokus = null;
  }

  function antLukkAlleArk(rot) {
    var apne = (rot || document).querySelectorAll(ANT_RAD + '[data-antrekk-apen]');
    for (var i = 0; i < apne.length; i++) antLukkArk(apne[i], false);
  }

  document.addEventListener('click', function (evt) {
    if (!evt.target.closest) return;

    var utloser = evt.target.closest('[data-antrekk-utloser]');
    if (utloser) {
      evt.preventDefault();
      var rad = utloser.closest(ANT_RAD);
      if (rad && rad.hasAttribute('data-antrekk-apen')) {
        antLukkArk(rad, true);
      } else {
        antApneArk(utloser);
      }
      return;
    }

    if (evt.target.closest('[data-antrekk-lukk]')) {
      evt.preventDefault();
      antLukkArk(evt.target.closest(ANT_RAD), true);
      return;
    }

    var bakteppe = evt.target.closest('[data-antrekk-bakteppe]');
    if (bakteppe) antLukkAlleArk(bakteppe.closest(ANT_ROT));
  });

  document.addEventListener('keyup', function (evt) {
    if (evt.key !== 'Escape') return;
    antLukkAlleArk(document);
  });

  /* Fokus skal ikke kunne forlate arket mens det er åpent. Ingen full
     fokusfelle med sentinel-noder: arket har få kontroller, og en enkel
     ombryting på Tab er nok – og mye mindre å ta feil av. */
  document.addEventListener('keydown', function (evt) {
    if (evt.key !== 'Tab') return;
    var apen = document.querySelector(ANT_RAD + '[data-antrekk-apen]');
    if (!apen) return;

    var panel = apen.querySelector('[data-antrekk-panel]');
    if (!panel) return;

    var felt = panel.querySelectorAll('button, [href], input:not([type="hidden"]):not(:disabled), [tabindex]:not([tabindex="-1"])');
    var synlige = [];
    for (var i = 0; i < felt.length; i++) {
      /* Skjulte fargegrupper skal ikke være med i syklusen. */
      if (felt[i].closest('[hidden]')) continue;
      synlige.push(felt[i]);
    }
    if (!synlige.length) return;

    var forste = synlige[0];
    var siste = synlige[synlige.length - 1];

    if (evt.shiftKey && (document.activeElement === forste || document.activeElement === panel)) {
      evt.preventDefault();
      siste.focus();
    } else if (!evt.shiftKey && document.activeElement === siste) {
      evt.preventDefault();
      forste.focus();
    }
  });

  /* ---- Endringer i valgene --------------------------------------------- */

  document.addEventListener('change', function (evt) {
    var mal = evt.target;
    if (!mal.closest) return;

    var rad = mal.closest(ANT_RAD);
    if (!rad) return;
    var seksjon = rad.closest(ANT_ROT);
    if (!seksjon) return;

    /* Størrelse valgt. */
    if (mal.hasAttribute('data-antrekk-variant')) {
      antSkjulFeil(rad);
      antTegnPris(
        rad,
        parseInt(mal.getAttribute('data-pris'), 10) || 0,
        parseInt(mal.getAttribute('data-forpris'), 10) || 0
      );
      antOppdaterUtloser(rad);
      antOppdaterKortknapp(rad);

      /* Et valg i et bunnark er ferdig i det det er tatt. Å la arket stå
         åpent etterpå tvinger kunden til å lukke det selv for å komme videre
         i lista. */
      if (antMobil()) antLukkArk(rad, true);

      /* Velger kunden størrelse på en rad hun har krysset bort, er
         handlingen i seg selv en beskjed om at hun vil ha plagget likevel. */
      var boks = rad.querySelector('[data-antrekk-velg]');
      if (boks && !boks.checked) boks.checked = true;

      antOppdaterSum(seksjon);
      return;
    }

    /* Avkryssing. */
    if (mal.hasAttribute('data-antrekk-velg')) {
      if (!mal.checked) antSkjulFeil(rad);
      antOppdaterSum(seksjon);
    }
  });

  /* ---- Kortmodus: vakt foran hurtigkjøpet ------------------------------

     Kortets skjema bærer `data-skogstad-hurtig`, og hurtigkjøpets egen
     lytter (søk «Produktkortet – fargeforhåndsvisning og hurtigkjøp») gjør
     resten. Den returnerer uten å gjøre noe hvis knappen mangler `value`, og
     da ville nettleseren postet skjemaet som vanlig: en tom `id` til
     /cart/add, en full sidelast, og en feilmelding uten sammenheng.

     Denne vakta ligger i CAPTURE-fasen, altså før lytterne i bobling, og
     stopper nettopp det tilfellet: ingen størrelse valgt ennå. Da sier
     kortet det selv, og på mobil åpnes størrelsesarket i samme bevegelse —
     kunden trykket «Legg i handlekurv» fordi hun vil ha plagget, og det
     neste hun trenger er størrelsene, ikke en beskjed om at hun mangler dem.

     Rekkefølgen kan ikke løses med registreringsrekkefølge: begge lytterne
     står på document, og hurtigkjøpet er registrert tidligere i fila. */
  document.addEventListener('submit', function (evt) {
    var skjema = evt.target;
    if (!skjema.matches || !skjema.matches('[data-antrekk-kortskjema]')) return;

    var rad = skjema.closest(ANT_RAD);
    if (!rad) return;
    if (antValgtVariant(rad)) return;

    evt.preventDefault();
    evt.stopPropagation();

    antVisFeil(rad, skjema.getAttribute('data-mangler-storrelse') || '');

    var utloser = rad.querySelector('[data-antrekk-utloser]');
    if (antMobil() && utloser && !utloser.hidden) {
      antApneArk(utloser);
      return;
    }

    /* Desktop: størrelsene ligger åpne i kortet. Fokus på den første som
       faktisk kan velges – ikke bare den første, som ofte er utsolgt. */
    var forste = rad.querySelector('[data-antrekk-variant]:not(:disabled)');
    if (forste) forste.focus();
  }, true);

  /* ---- Legg valgte i handlekurven -------------------------------------- */

  document.addEventListener('submit', function (evt) {
    var skjema = evt.target;
    if (!skjema.matches || !skjema.matches(ANT_SKJEMA)) return;

    /* Uten fetch lar vi nettleseren poste skjemaet som vanlig. Da havner
       kunden på handlekurven i stedet for i skuffa – tregere, men riktig. */
    if (!window.fetch) return;

    evt.preventDefault();

    var seksjon = skjema.closest(ANT_ROT);
    var knapp = skjema.querySelector('[data-antrekk-kjop]');
    var melding = skjema.querySelector('[data-antrekk-melding]');
    if (!seksjon || !knapp) return;

    /* Dobbeltklikk og Enter-Enter er den vanligste veien til to like linjer i
       kurven. Låsen står til svaret er kommet, uansett hvordan det gikk. */
    if (knapp.hasAttribute('data-laster')) return;

    if (melding) {
      melding.hidden = true;
      melding.textContent = '';
    }

    var rader = seksjon.querySelectorAll(ANT_RAD);
    var varer = [];
    var forsteMangel = null;

    for (var i = 0; i < rader.length; i++) {
      antSkjulFeil(rader[i]);
      if (!antErValgt(rader[i])) continue;

      var valgt = antValgtVariant(rader[i]);
      if (!valgt || !valgt.value) {
        /* Ikke feil stille, og aldri alert(). Raden merkes, feltet under den
           sier hva som mangler, og fokus flyttes til den første. */
        antVisFeil(rader[i], skjema.getAttribute('data-mangler-storrelse') || '');
        if (!forsteMangel) forsteMangel = rader[i];
        continue;
      }

      varer.push({ id: parseInt(valgt.value, 10), quantity: 1 });
    }

    if (forsteMangel) {
      var utloser = forsteMangel.querySelector('[data-antrekk-utloser]');
      var forsteKnapp = forsteMangel.querySelector('[data-antrekk-variant]:not(:disabled)');
      var mal = (utloser && !utloser.hidden && antMobil()) ? utloser : forsteKnapp;
      if (mal) mal.focus();
      antOppdaterSum(seksjon);
      return;
    }

    if (!varer.length) {
      if (melding) {
        melding.textContent = skjema.getAttribute('data-ingen-valgt') || '';
        melding.hidden = false;
      }
      return;
    }

    var normalEtikett = knapp.getAttribute('data-etikett') || knapp.textContent;

    /* Her, og bare her, er knappen faktisk utilgjengelig: forespørselen er
       sendt, og et nytt trykk ville lagt antrekket i kurven to ganger.
       `disabled` og ikke aria-disabled – tilstanden er ekte og varer i noen
       hundre millisekunder. */
    knapp.setAttribute('data-laster', '');
    knapp.disabled = true;
    knapp.textContent = skjema.getAttribute('data-legger-til') || normalEtikett;

    function antTilbakestillKnapp() {
      knapp.removeAttribute('data-laster');
      knapp.disabled = false;
      knapp.textContent = normalEtikett;
      antOppdaterSum(seksjon);
    }

    /* ÉN forespørsel, ikke én per plagg. /cart/add tar imot en items-liste,
       og det er både raskere og trygt: enten legges hele antrekket inn, eller
       ingenting. Sekvensielle kall ville kunnet ende med to av fire plagg i
       kurven hvis nettet falt ut underveis, og kunden ville sett en halv
       ordre uten å forstå hvorfor. */
    var url = (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js';

    fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: varer })
    })
      .then(function (svar) {
        return svar.json().then(function (data) {
          return { ok: svar.ok, data: data };
        });
      })
      .then(function (resultat) {
        antTilbakestillKnapp();

        /* 422 = varen kan ikke legges i kurven. I praksis: noen andre kjøpte
           den siste mens seksjonen lå åpen. Meldingen fra Shopify er allerede
           på norsk og forklarer hva som er galt. */
        if (!resultat.ok || (resultat.data && (resultat.data.status === 422 || resultat.data.status === 404))) {
          if (melding) {
            melding.textContent =
              (resultat.data && (resultat.data.description || resultat.data.message)) ||
              skjema.getAttribute('data-nettverksfeil') || '';
            melding.hidden = false;
          }
          return;
        }

        antLukkAlleArk(seksjon);

        /* Handlekurv som egen side: da er det ingen skuff å åpne. */
        if (window.theme && theme.settings && theme.settings.cartType === 'page') {
          window.location = (theme.routes && theme.routes.cartPage) || '/cart';
          return;
        }

        /* Impulses egen hendelse. theme.js sin CartDrawer lytter på den,
           bygger kurven på nytt og åpner skuffa. Vi skriver ingen kurvlogikk
           selv – det er den samme veien produktsidens «Legg i handlekurv»
           går, og derfor virker fraktmåleren og mersalget i skuffa uten et
           eneste tillegg her.

           Vi sender IKKE 'cart:build' i tillegg – CartDrawer bygger kurven
           selv når den hører 'ajaxProduct:added', og to hendelser ville gitt
           to like nettverkskall.

           En merknad om theme.js: gavekortlytteren der leser
           event.target.querySelector('[name="id"]').value. Skjemaet vårt har
           ikke noe felt som heter «id» – det heter items[0][id] – så den
           lytteren ville kastet på hendelsen vår. Den finnes bare når
           <product-recipient-form> er koblet til, altså på gavekortets
           produktside, og aldri på forsiden. Og et unntak i én lytter stopper
           ikke de andre: CartDrawer får hendelsen uansett. Vi legger derfor
           IKKE inn et tomt name="id"-felt for å blidgjøre den – det ville
           blitt postet som en tom variant-id på /cart/add uten JavaScript, og
           ødelagt nøyaktig det som skulle virke uten skript. */
        skjema.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { product: resultat.data, addToCartBtn: knapp },
          bubbles: true
        }));
      })
      .catch(function () {
        antTilbakestillKnapp();
        if (melding) {
          melding.textContent = skjema.getAttribute('data-nettverksfeil') || '';
          melding.hidden = false;
        }
      });
  });

  /* ---- Per node: slå på det som ikke skal finnes uten skript ----------- */

  function initAntrekk(rot) {
    var omraade = rot || document;
    var seksjoner = omraade.querySelectorAll(ANT_ROT);

    for (var s = 0; s < seksjoner.length; s++) {
      var seksjon = seksjoner[s];

      /* Avkryssingen. Uten skript er «velg bort» meningsløst, og en hake som
         ikke kan slås av er verre enn ingen hake. */
      var bokser = seksjon.querySelectorAll('[data-antrekk-velgboks]');
      for (var b = 0; b < bokser.length; b++) bokser[b].removeAttribute('hidden');

      var rader = seksjon.querySelectorAll(ANT_RAD);
      for (var r = 0; r < rader.length; r++) {
        var rad = rader[r];

        /* Første fargebrikke blir tabbar nå som det finnes et skript som gjør
           noe når den trykkes. */
        var forsteBrikke = rad.querySelector('[data-antrekk-brikke]');
        if (forsteBrikke) forsteBrikke.setAttribute('tabindex', '0');

        /* Mobilutløseren avdekkes. CSS bestemmer om den faktisk vises – den
           er skjult over 768 px – men uten skript skal den ikke finnes.
           Produkter uten størrelsesvalg har ingenting å åpne, og beholder
           den skjult. */
        /* Plagg uten størrelsesvalg (lue, buff, OneSize) har en fast skjult
           input og er «valgt» fra start – knappen skal ha verdien med en
           gang, ikke først etter en endring som aldri kommer. */
        antOppdaterKortknapp(rad);

        var utloser = rad.querySelector('[data-antrekk-utloser]');
        if (utloser) {
          var harStorrelser = rad.querySelector('[data-antrekk-variant]');
          if (harStorrelser) {
            var tekst = utloser.querySelector('[data-antrekk-utlosertekst]');
            if (tekst && !utloser.getAttribute('data-standardtekst')) {
              utloser.setAttribute('data-standardtekst', tekst.textContent.trim());
            }
            utloser.removeAttribute('hidden');
            antOppdaterUtloser(rad);
          }
        }
      }

      antOppdaterSum(seksjon);
    }
  }

  /* ------------------------------------------------------------------------
     Antrekk – faner og sveip

     sections/skogstad-antrekk.liquid
     Stiler: skogstad-globalt.css (søk «Seksjonshodet, fanerada og sveipen»)

     TO NAVIGASJONER, ETT INNHOLD
     Fanene velger målgruppe (hvilket panel som vises), sveipen velger antrekk
     innenfor målgruppa (hvor langt sporet er scrollet). De rører aldri det
     samme: fanen setter `hidden` på paneler, sveipen setter scrollLeft på et
     spor. Derfor kan de leve ved siden av hverandre uten en delt tilstand som
     skal holdes i takt.

     HVA SOM SKJER UTEN DETTE SKRIPTET
     Sporet scroller fortsatt – med fingeren, med trackpad, med hjul og med
     tastatur, fordi det er en helt vanlig `overflow-x: auto`. Det som
     forsvinner er pilene og prikkene (`hidden` i markupen) og fanerada
     (`visibility: hidden` til merket under er satt). Da vises den første
     gruppa, og den fungerer fullt ut. Ingen døde knapper.

     INGEN AUTOMATISK ROTASJON
     Ikke fordi den er vanskelig, men fordi et antrekk er noe kunden leser:
     fire produktnavn, fire priser, fire størrelsesvalg. Et lysbilde som
     bytter seg selv midt i lesingen er en seksjon som tar tilbake valget den
     nettopp ga fra seg.

     POSISJONEN LESES AV SPORET, DEN LAGRES IKKE
     Ingen «aktiv indeks» noe sted. scrollLeft delt på bredden ER indeksen, og
     den er riktig uansett hvordan kunden kom dit – piltrykk, prikk, sveip
     eller tabulator inn i et skjema lenger ute i rekka. En egen teller ville
     vært en andre sannhet, og den ville løyet første gang fingeren dro.

     ET SKJULT PANEL HAR BREDDE 0
     Panelene til fanene som ikke er valgt måler null, og tegn() gjør derfor
     ingenting for dem. Fanebyttet kaller tegn() på nytt for panelet som ble
     synlig – samme grep som sveiperaden i Nyheter bruker.
     ------------------------------------------------------------------------ */

  var ANT_SEKSJONSROT = '[data-antrekk-rot]';
  var ANT_FANE = '[data-antrekk-fane]';
  var ANT_FANEPANEL = '[data-antrekk-fanepanel]';
  var ANT_KARUSELL = '[data-antrekk-karusell]';
  var ANT_LYSBILDE = '[data-antrekk-lysbilde]';

  function antTegnKaruseller(rot) {
    var karuseller = (rot || document).querySelectorAll(ANT_KARUSELL);
    for (var i = 0; i < karuseller.length; i++) {
      if (typeof karuseller[i].skogstadTegnKarusell === 'function') {
        karuseller[i].skogstadTegnKarusell();
      }
    }
  }

  /* ---- Fanene ---------------------------------------------------------- */

  function antFaneListe(seksjon) {
    return Array.prototype.slice.call(seksjon.querySelectorAll(ANT_FANE));
  }

  function antVisFane(seksjon, fane, flyttFokus) {
    var faner = antFaneListe(seksjon);
    for (var i = 0; i < faner.length; i++) {
      var valgt = faner[i] === fane;
      faner[i].setAttribute('aria-selected', valgt ? 'true' : 'false');

      /* Rullerende tabindex: hele rada er ett tabstopp. Fem tabstopp mellom
         overskriften og det første produktet ville vært fem for mange. */
      faner[i].setAttribute('tabindex', valgt ? '0' : '-1');
    }

    /* Et bunnark som står åpent i panelet vi forlater ville blitt hengende
       som en fast dialog over et innhold som ikke lenger finnes. */
    antLukkAlleArk(seksjon);

    var maal = fane.getAttribute('aria-controls');
    var paneler = seksjon.querySelectorAll(ANT_FANEPANEL);
    for (var p = 0; p < paneler.length; p++) {
      var treff = paneler[p].id === maal;
      paneler[p].hidden = !treff;

      /* Panelet hadde bredde 0 i det det var skjult, så sveipekontrollene
         kunne ikke måles. Nå kan de. */
      if (treff) antTegnKaruseller(paneler[p]);
    }

    /* Bare ved tastaturnavigasjon. Ved museklikk har fanen allerede fokus, og
       et programmatisk focus() ville utløst fokusringen på et klikk. */
    if (flyttFokus) fane.focus();
  }

  document.addEventListener('click', function (evt) {
    if (!evt.target.closest) return;
    var fane = evt.target.closest(ANT_FANE);
    if (!fane) return;

    var seksjon = fane.closest(ANT_SEKSJONSROT);
    if (!seksjon) return;

    /* Klikk på den fanen som allerede er valgt skal ikke fade panelet ut og
       inn igjen. Ingenting endret seg. */
    if (fane.getAttribute('aria-selected') === 'true') return;

    seksjon.setAttribute('data-antrekk-byttet', '');
    antVisFane(seksjon, fane, false);
  });

  document.addEventListener('keydown', function (evt) {
    var tast = evt.key;
    if (tast !== 'ArrowLeft' && tast !== 'ArrowRight' && tast !== 'Home' && tast !== 'End') return;
    if (!evt.target.closest) return;

    var fane = evt.target.closest(ANT_FANE);
    if (!fane) return;

    var seksjon = fane.closest(ANT_SEKSJONSROT);
    if (!seksjon) return;

    var faner = antFaneListe(seksjon);
    var naa = faner.indexOf(fane);
    if (naa === -1) return;

    /* Rundgang i begge ender. En fanerad er en sirkel, ikke en linje med
       vegger – å stoppe på den siste fanen gir ingen informasjon. */
    var neste;
    if (tast === 'Home') {
      neste = 0;
    } else if (tast === 'End') {
      neste = faner.length - 1;
    } else if (tast === 'ArrowLeft') {
      neste = (naa - 1 + faner.length) % faner.length;
    } else {
      neste = (naa + 1) % faner.length;
    }

    /* Piltastene ville ellers scrollet fanerada vannrett. */
    evt.preventDefault();

    seksjon.setAttribute('data-antrekk-byttet', '');
    antVisFane(seksjon, faner[neste], true);
  });

  /* ---- Sveipen --------------------------------------------------------- */

  function antLysbilder(spor) {
    return Array.prototype.slice.call(spor.querySelectorAll(ANT_LYSBILDE));
  }

  /* Indeksen leses av lysbildenes egen plassering i sporet og ikke av
     scrollLeft delt på bredden. Sporet har luft mellom lysbildene, og et
     regnestykke på bredden alene ville bommet med ett gap for hvert lysbilde
     – på det fjerde antrekket nok til å peke på feil prikk. `offsetLeft` er
     målt av nettleseren og inkluderer gapet. */
  function antIndeks(spor) {
    var bredde = spor.clientWidth;
    if (!bredde) return 0;

    var lysbilder = antLysbilder(spor);
    if (!lysbilder.length) return 0;

    /* offsetLeft måles fra nærmeste posisjonerte forelder, som kan ligge
       utenfor sporet. Nullpunktet trekkes derfor fra – da er tallene i samme
       målestokk som scrollLeft uansett hvor den forelderen står. */
    var null_punkt = lysbilder[0].offsetLeft;
    var maal = spor.scrollLeft;
    var beste = 0;
    var minste = Infinity;
    for (var n = 0; n < lysbilder.length; n++) {
      var avstand = Math.abs(lysbilder[n].offsetLeft - null_punkt - maal);
      if (avstand < minste) {
        minste = avstand;
        beste = n;
      }
    }
    return beste;
  }

  /* Posisjonen settes med scrollLeft og ikke scrollTo({behavior}). Glidningen
     ligger i CSS (`scroll-behavior: smooth` på sporet), og der slås den også
     av under prefers-reduced-motion. Ett sted, ikke to. */
  function antGaaTil(spor, indeks) {
    var lysbilder = antLysbilder(spor);
    if (!lysbilder.length) return;
    if (indeks < 0) indeks = 0;
    if (indeks > lysbilder.length - 1) indeks = lysbilder.length - 1;
    spor.scrollLeft = lysbilder[indeks].offsetLeft - lysbilder[0].offsetLeft;
  }

  function koblAntrekkKarusell(karusell) {
    /* Temaeditoren kan sende samme node inn flere ganger. Uten dette merket
       ville hver runde lagt på enda et sett lyttere. */
    if (karusell.getAttribute('data-karusell-koblet') === 'true') return;

    var spor = karusell.querySelector('[data-antrekk-spor]');
    if (!spor) return;

    karusell.setAttribute('data-karusell-koblet', 'true');

    var nav = karusell.querySelector('[data-antrekk-nav]');
    var forrige = karusell.querySelector('[data-antrekk-pil="forrige"]');
    var neste = karusell.querySelector('[data-antrekk-pil="neste"]');
    var planlagt = false;

    function tegn() {
      planlagt = false;
      if (!nav) return;

      var bredde = spor.clientWidth;

      /* Skjult panel: ingenting å måle, og ingenting skal endres. Panelet
         måles på nytt i det fanen velges. */
      if (!bredde) return;

      var lysbilder = antLysbilder(spor);
      if (lysbilder.length < 2) {
        nav.hidden = true;
        return;
      }

      nav.hidden = false;

      var i = antIndeks(spor);
      var prikker = karusell.querySelectorAll('[data-antrekk-prikk]');
      for (var p = 0; p < prikker.length; p++) {
        prikker[p].setAttribute('aria-current', p === i ? 'true' : 'false');
      }

      /* Halvpiksler i layouten gjør at enden kan ligge på 0,5 px. Terskelen
         på 1 og ikke 0 er derfor ikke slurv – uten den ville «neste» stått
         aktiv på siste lysbilde i noen nettlesere. */
      if (forrige) forrige.disabled = spor.scrollLeft <= 1;
      if (neste) neste.disabled = spor.scrollLeft >= spor.scrollWidth - spor.clientWidth - 1;
    }

    karusell.skogstadTegnKarusell = tegn;

    spor.addEventListener('scroll', function () {
      if (planlagt) return;
      planlagt = true;
      window.requestAnimationFrame(tegn);
    }, { passive: true });

    tegn();
  }

  document.addEventListener('click', function (evt) {
    if (!evt.target.closest) return;

    var pil = evt.target.closest('[data-antrekk-pil]');
    if (pil) {
      var karusellP = pil.closest(ANT_KARUSELL);
      var sporP = karusellP && karusellP.querySelector('[data-antrekk-spor]');
      if (!sporP) return;

      /* Et ark som står åpent hører til lysbildet vi forlater. */
      antLukkAlleArk(karusellP);

      var retning = pil.getAttribute('data-antrekk-pil') === 'neste' ? 1 : -1;
      antGaaTil(sporP, antIndeks(sporP) + retning);
      return;
    }

    var prikk = evt.target.closest('[data-antrekk-prikk]');
    if (prikk) {
      var karusellD = prikk.closest(ANT_KARUSELL);
      var sporD = karusellD && karusellD.querySelector('[data-antrekk-spor]');
      if (!sporD) return;

      antLukkAlleArk(karusellD);
      antGaaTil(sporD, parseInt(prikk.getAttribute('data-antrekk-prikk'), 10) || 0);
    }
  });

  /* ---- Per node -------------------------------------------------------- */

  function initAntrekkNavigasjon(rot) {
    var omraade = rot || document;

    /* Fanerada er `visibility: hidden` til dette merket er satt. Uten skript
       er den en tom stripe og ikke fire døde knapper – samme regel som
       fanerada i Nyheter og framdriftsindikatoren i kategori-railen følger. */
    var seksjoner = omraade.querySelectorAll(ANT_SEKSJONSROT);
    for (var s = 0; s < seksjoner.length; s++) {
      if (!seksjoner[s].querySelector('[data-antrekk-faner]')) continue;
      seksjoner[s].setAttribute('data-antrekk-faner', 'klar');
    }

    var karuseller = omraade.querySelectorAll(ANT_KARUSELL);
    for (var k = 0; k < karuseller.length; k++) {
      koblAntrekkKarusell(karuseller[k]);
    }
  }

  /* Én lytter for hele siden, ikke én per karusell: nodene byttes ut ved hver
     endring i temaeditoren, og lyttere på gamle noder ville hopet seg opp.
     Bredden endrer seg både ved rotasjon og når rullefeltet kommer til. */
  window.addEventListener('resize', function () {
    antTegnKaruseller(document);
  });

  /* Redaktøren velger en look-blokk i editoren. Ligger den under en annen
     fane eller lenger ute i sveipen, ville Shopify scrollet til en node som
     er `hidden` eller utenfor sporet – og redaktøren ville sett en seksjon
     som ikke reagerte på klikket sitt. */
  document.addEventListener('shopify:block:select', function (evt) {
    if (!evt.target || !evt.target.closest) return;

    var lysbilde = evt.target.closest(ANT_LYSBILDE);
    if (!lysbilde) return;

    var seksjon = lysbilde.closest(ANT_SEKSJONSROT);
    var panel = lysbilde.closest(ANT_FANEPANEL);
    if (seksjon && panel) {
      var fane = seksjon.querySelector(ANT_FANE + '[aria-controls="' + panel.id + '"]');
      if (fane && fane.getAttribute('aria-selected') !== 'true') {
        antVisFane(seksjon, fane, false);
      }
    }

    var spor = lysbilde.closest('[data-antrekk-spor]');
    if (!spor) return;

    var i = antLysbilder(spor).indexOf(lysbilde);
    if (i > -1) antGaaTil(spor, i);
  });

  /* Bytter kunden fra mobil til desktop mens et ark står åpne, skal arket
     ikke bli hengende som en dialog i en rad. */
  window.addEventListener('resize', function () {
    if (!antMobil()) antLukkAlleArk(document);
  });

  function init() {
    initFilterToggle();
    initFilterUX();

    initAnnouncementRotation();
    initKategorirail();
    initNyhetsfaner();
    initNyhetsrail();
    initProduktkort();
    initKolleksjonskort();
    initAntrekk();
    initAntrekkNavigasjon();

    if (!document.querySelector(SELECTOR_BAR)) return;

    // Dekker antallsendring, som er den ene veien Impulse faktisk varsler om.
    document.addEventListener('cart:updated', function (evt) {
      if (evt.detail && evt.detail.cart) updateShippingBars(evt.detail.cart.total_price);
    });

    // Dekker alt annet: legg i handlekurv, sideinnlasting, og enhver
    // framtidig vei som går gjennom buildCart().
    var products = document.querySelector(SELECTOR_PRODUCTS);
    if (products) {
      new MutationObserver(syncFromMarkup).observe(products, { childList: true, subtree: true });
    }

    // Selvretting: markupen kan allerede være på plass når dette kjører, og
    // serverrendret verdi kan være foreldet hvis siden kom fra bufferen.
    syncFromMarkup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Temaeditoren bytter ut hele seksjonen ved hver endring. Uten dette ville
  // rotasjonen sluttet å virke så snart redaktøren rørte en innstilling.
  document.addEventListener('shopify:section:load', function (evt) {
    if (evt.target.querySelector('#SkogstadAnnouncement')) initAnnouncementRotation();

    // Kategori-railen bygges også på nytt: ny markup betyr nye noder, og
    // koblingsmerket forsvant sammen med den gamle.
    initKategorirail(evt.target);

    // Målgruppefanene i Nyheter: rada er ny markup uten «klar»-merket, og
    // ville stått usynlig igjen etter hver endring i editoren.
    initNyhetsfaner(evt.target);

    // Sveiperaden i Nyheter: nye paneler uten koblingsmerke, og en rullestrek
    // som står `hidden` til noen har målt at det finnes noe å scrolle til.
    initNyhetsrail(evt.target);

    // Produktkortene: samme grunn. Kortene er nye noder etter hver endring i
    // editoren, og brikkene deres står igjen med tabindex="-1". Gjelder alle
    // seksjoner som rendrer kortet – Nyheter og Bestselgere i dag.
    initProduktkort(evt.target);

    // «Kle deg lag på lag»: haken, mobilutløseren og totalsummen bor på noder
    // som er byttet ut. Uten dette ville seksjonen stått med en sum fra før
    // redaktøren endret produktene.
    initAntrekk(evt.target);

    // Fanerada og sveipekontrollene: samme grunn igjen. Merket som gjør
    // fanerada synlig og koblingsmerket på karusellen forsvant sammen med den
    // gamle markupen, og et nytt spor er umålt til noen måler det.
    initAntrekkNavigasjon(evt.target);
  });

  /* «Gjør antrekket komplett» på produktsiden kommer inn etter sidelast.
     Lagt til 21.09.2026.

     sections/skogstad-pdp-antrekk.liquid rendres av anbefalingsruten:
     <product-recommendations> i theme.js henter seksjonen og bytter inn
     innholdet, og sender så `recommendations:loaded`. Radene er altså nye
     noder som init aldri har sett.

     Delegeringen fra document virker på dem uansett – det er derfor alt er
     delegert – men haken og mobilutløseren står `hidden` i markupen til
     skriptet avdekker dem, og det er per node. Uten dette ville seksjonen
     stått med synlige størrelsesvelgere og usynlige avkryssinger: kunden
     kunne velge størrelse, men ikke velge bort et plagg.

     `evt.detail.section` er <product-recommendations>-elementet. Vi sender
     det som rot, ikke document, slik at «Relevante produkter» og «Passer
     sammen med» – som sender den samme hendelsen – ikke drar en unødvendig
     runde gjennom hele siden.

     `initNyhetsrail` i tillegg fra 21.09.2026: kortene ligger nå i den samme
     sveiperailen som Nyheter og Relevante produkter, og railen måles per
     node — piler, rullestrek og dragging kobles i `koblNyhetsrail`. Uten
     dette kallet ville sporet scrollet (det er ren CSS), men pilene og
     streken ville stått `hidden` for alltid: ingen hadde målt om det fantes
     noe å scrolle. */
  document.addEventListener('recommendations:loaded', function (evt) {
    var rot = evt.detail && evt.detail.section;
    if (!rot || !rot.querySelector(ANT_ROT)) return;
    initAntrekk(rot);
    initNyhetsrail(rot);
  });

  /* ------------------------------------------------------------------------
     Filterlister – «Vis flere»

     Markupen kommer fra snippets/collection-grid-filters-form.liquid: en
     <ul class="skogstad-tag-list--avkortet"> der radene forbi den åttende har
     .skogstad-tag--skjult, etterfulgt av knappen [data-skogstad-vis-flere].

     Hvorfor delegert lytter og ikke én per knapp: filterskjemaet rendres to
     ganger på samme side (sidestolpen og mobilskuffen), og Impulse bytter ut
     hele rutenettet med ny markup ved hvert filtervalg. Knapper som ble
     koblet ved sideinnlasting hadde vært døde etter første klikk i et annet
     filter. En lytter på document overlever alle utskiftninger.

     Lista utvides varig i den økta – vi kollapser den ikke igjen når
     rutenettet lastes på nytt, fordi kunden som nettopp åpnet «vis flere»
     som regel er på vei til å velge nummer to fra samme liste.
     ------------------------------------------------------------------------ */
  document.addEventListener('click', function (evt) {
    var knapp = evt.target.closest('[data-skogstad-vis-flere]');
    if (!knapp) return;

    var liste = knapp.previousElementSibling;
    while (liste && liste.tagName !== 'UL') liste = liste.previousElementSibling;
    if (!liste) return;

    var utvidet = liste.classList.toggle('er-utvidet');
    knapp.setAttribute('aria-expanded', utvidet ? 'true' : 'false');
    knapp.textContent = utvidet
      ? knapp.getAttribute('data-faerre')
      : knapp.getAttribute('data-mer');

    // Gruppa ligger i en collapsible med låst høyde. Uten dette vokser
    // innholdet ut av containeren og de nye radene blir klippet bort.
    var innhold = knapp.closest('.collapsible-content');
    if (innhold && innhold.style.height && innhold.style.height !== 'auto') {
      innhold.style.height = 'auto';
    }
  });

  // Nettleserens tilbakeknapp kan servere siden fra bfcache med gammel kurv.
  window.addEventListener('pageshow', function (evt) {
    if (evt.persisted) syncFromMarkup();
  });
})();
